export const DASHBOARD_SIDE_BAR = [
	{
		portal: 'dashboard_api',
		apiFolder: [
			// _______ Authentication _________
			{
				name: 'authentication',
				id: 'authentication',
				bold: 'true',
				types: [
					{
						name: 'login',
						id: 'login'
					},
					{
						name: 'forgot_password',
						id: 'forgot-password'
					},
					{
						name: 'change_password',
						id: 'change-password'
					},
					// {
					// 	name: 'candidate_token',
					// 	id: 'candidate-token'
					// },
					{
						name: 'me',
						id: 'me'
					},
					{
						name: 'google_api_login',
						id: 'google-api-login'
					},
					{
						name: 'send_otp',
						id: 'send-otp'
					},
					{
						name: 'verify_otp',
						id: 'verify-otp'
					},
					{
						name: 'login_with_microsoft_entra',
						id: 'login-with-microsoft-entra'
					},
				]
			},

			// _______ 2FA Authentication _________
			{
				name: '2fa_authentication',
				id: '2fa-authentication',
				types: [
					{
						name: 'generate_2fa',
						id: 'generate-2fa'
					},
					{
						name: 'verify_2fa',
						id: 'verify-2fa'
					},
					{
						name: 'verify_2fa_login',
						id: 'verify-2fa-login'
					},
					{
						name: 'check_2fa',
						id: 'check-2fa'
					},
					{
						name: 'change_2fa_status',
						id: 'change-2fa-status'
					},
				]
			},

			// ____________ AI Events _______________
			{
				name: 'ai_events',
				id: 'ai-events',
				types: [
					{
						name: 'create_ai_events',
						id: 'create-ai_events',
					},
					{
						name: 'ai_events_by_candidate',
						id: 'create-ai_events-by-candiates',
					},
					{
						name: 'edit_ai_events',
						id: 'edit-ai_events'
					},
					{
						name: 'delete_ai_events',
						id: 'delete-ai_events'
					},
					{
						name: 'get_all_ai_events',
						id: 'get-all-ai_events'
					},
					{
						name: 'bulk_ai_events',
						id: 'bulk-ai-events'
					},
					{
						name: 'candidate_bulk_ai_events',
						id: 'candidate-bulk-ai-events'
					},
				]
			},

			// ____________ Alerts ___________
			{
				name: 'alert',
				id: 'alert',
				types: [
					{
						name: 'create_alert',
						id: 'create-alert',
					},
					{
						name: 'edit_alert',
						id: 'edit-alert'
					},
					{
						name: 'delete_alert',
						id: 'delete-alert'
					},
					{
						name: 'get_all_alert',
						id: 'get-all-alert'
					},
					{
						name: 'search_alert',
						id: 'search-alert'
					},
					{
						name: 'bulk_edit_alert',
						id: 'bulk-edit-alert'
					},
				]
			},

			// ____________ Alerts Types ___________
			{
				name: 'alert_types',
				id: 'alert-types',
				types: [
					{
						name: 'create_alert_type',
						id: 'create-alert-types',
					},
					{
						name: 'edit_alert_type',
						id: 'edit-alert-types'
					},
					{
						name: 'delete_alert_types',
						id: 'delete-alert-types'
					},
					{
						name: 'get_all_alert_types',
						id: 'get-all-alert-types'
					}
				]
			},

			// __________ Analytics ____________
			{
				name: 'analytics',
				id: 'analytics',
				types: [
					{
						name: 'user_conversion',
						id: 'user-conversion',
					},
					{
						name: 'playlist_conversion_count_and_time',
						id: 'playlist-conversion-count-and-time'
					},
					{
						name: 'create_assessment_time_to_process',
						id: 'create-assessment-time-to-process'
					},
					{
						name: 'average_score',
						id: 'average-score'
					},
					{
						name: 'average_time_spent_on_item',
						id: 'average-time-spent-on-item'
					},
					{
						name: 'dashboard_stats',
						id: 'dashboard-stats'
					},
				]
			},

			// __________ Assessment ____________
			{
				name: 'assessment',
				id: 'assessment',
				types: [
					{
						name: 'create_assessment',
						id: 'create-assessment',
					},
					{
						name: 'edit_assessment',
						id: 'edit-assessment'
					},
					{
						name: 'delete_assessment',
						id: 'delete-assessment'
					},
					{
						name: 'search_assessment',
						id: 'search-assessment'
					},
					{
						name: 'duplicate_assessment',
						id: 'duplicate-assessment'
					},
					{
						name: 'change_assessment_date',
						id: 'change-assessment-date'
					},
					{
						name: 'get_all_assessments',
						id: 'get-all-assessments'
					},
					{
						name: 'post_assessment_with_section',
						id: 'post-assessment-with-section'
					},
					{
						name: 'update_assessment_with_section',
						id: 'update-assessment-with-section'
					},
					{
						name: 'public_assessment',
						id: 'public-assessment'
					},
				]
			},

			// _____________ Assessment Report ________________
			{
				name: 'assessment_report',
				id: 'assessment-report',
				types: [
					{
						name: 'create_report',
						id: 'create-report',
					},
					{
						name: 'edit_report',
						id: 'edit-report'
					},
					{
						name: 'delete_report',
						id: 'delete-report'
					},
					{
						name: 'get_all_report',
						id: 'get-all-report'
					},
				]
			},

			// _____________ Assessment Status ____________
			{
				name: 'assessment_status',
				id: 'assessment-status',
				types: [
					{
						name: 'create_assessment_status',
						id: 'create-assessment-status',
					},
					{
						name: 'edit_assessment_status',
						id: 'edit-assessment-status'
					},
					{
						name: 'delete_assessment_status',
						id: 'delete-assessment-status'
					},
					{
						name: 'get_all_assessment_status',
						id: 'get-all-assessment-status'
					},
				]
			},

			// ______________Candiates ______________
			{
				name: 'candidate',
				id: 'candidate',
				types: [
					{
						name: 'get_all_candidates',
						id: 'get-all-candidates'
					},
					{
						name: 'create_candidate',
						id: 'create-candidate',
					},
					{
						name: 'edit_candidate',
						id: 'edit-candidate'
					},
					{
						name: 'delete_candidate',
						id: 'delete-candidate'
					},
					{
						name: 'search_candidate',
						id: 'search-candidate'
					},
					{
						name: 'add_candidate_bulk',
						id: 'add-candidate-bulk'
					},
					{
						name: 'register_candidate',
						id: 'register-candidate'
					},
				]
			},

			// ____________ Candidate Assessment Invite Status 
			{
				name: 'candidate_assessment_section_invite_status',
				id: 'candidate-assessment-section-invite-status',
				types: [
					{
						name: 'create_candidate_assessment_section_invite_status',
						id: 'create-candidate-assessment-section-invite-status',
					},
					{
						name: 'edit_candidate_assessment_section_invite_status',
						id: 'edit-candidate-assessment-section-invite-status'
					},
					{
						name: 'delete_candidate_assessment_section_invite_status',
						id: 'delete-candidate-assessment-section-invite-status'
					},
					{
						name: 'get_all_candidate_assessment_section_invite_status',
						id: 'get-all-candidate-assessment-section-invite-status'
					},
				]
			},

			// ____________ Candidate assessment status _________
			{
				name: 'candidate_assessment_status',
				id: 'candidate-assessment-status',
				types: [
					{
						name: 'create_candidate_assessment_status',
						id: 'create-candidate-assessment-status',
					},
					{
						name: 'edit_candidate_assessment_status',
						id: 'edit-candidate-assessment-status'
					},
					{
						name: 'delete_candidate_assessment_status',
						id: 'delete-candidate-assessment-status'
					},
					{
						name: 'get_all_candidate_assessment_status',
						id: 'get-all-candidate-assessment-status'
					},
				]
			},

			// ______________ Candidate Feedback ____________
			{
				name: 'candidate_feedback',
				id: 'candidate-feedback',
				types: [
					{
						name: 'create_feedback',
						id: 'create-feedback',
					},
					{
						name: 'edit_feedback',
						id: 'edit-feedback'
					},
					{
						name: 'delete_feedback',
						id: 'delete-feedback'
					},
					{
						name: 'get_all_feedback',
						id: 'get-all-feedback'
					},
					{
						name: 'create_candidate_assessment_feedback_by_candidate',
						id: 'create-candidate-assessment-feedback-by-candidate'
					},
				]
			},

			// _____________ Candidate Invite Assessment __________
			{
				name: 'candidate_invite_assessment',
				id: 'candidate-invite-assessment',
				types: [
					{
						name: 'create_candidate_invite_assessment',
						id: 'create-candidate-invite-assessment',
					},
					{
						name: 'edit_candidate_invite_assessment',
						id: 'edit-candidate-invite-assessment'
					},
					{
						name: 'delete_candidate_invite_assessment',
						id: 'delete-candidate-invite-assessment'
					},
					{
						name: 'get_all_candidate_invite_assessment',
						id: 'get-all-candidate-invite-assessment'
					},
					{
						name: 'public_candidate_invite_assessment_section',
						id: 'public-candidate-invite-assessment-section'
					},
					{
						name: 'change_candidate_invite_assessment_section_status',
						id: 'change-candidate-invite-assessment-section-status'
					},
					{
						name: 'candidate_assessment_section_invite_search',
						id: 'candidate-assessment-section-invite-search'
					},
					{
						name: 'edit_candidate_assessment_section_invite_bulk',
						id: 'edit-candidate-assessment-section-invite-bulk'
					},
					{
						name: 'search_invited_candidate_by_assessment',
						id: 'search-invited-candidate-by-assessment'
					}
				]
			},

			// ___________ Candidates Assessments __________
			{
				name: 'candidates_assessment',
				id: 'candidates-assessment',
				types: [
					{
						name: 'create_candidates_assessment',
						id: 'create-candidates-assessment',
					},
					{
						name: 'edit_candidates_assessment',
						id: 'edit-candidates_assessment'
					},
					{
						name: 'delete_candidates_assessment',
						id: 'delete-candidates_assessment'
					},
					{
						name: 'get_all_candidates_assessments',
						id: 'get-all-candidates_assessments'
					},
					{
						name: 'bulk_update_candidate_assessment',
						id: 'bulk-update-candidate-assessment'
					},
					{
						name: 'change_candidate_assessment_status',
						id: 'change-candidate-assessment-status'
					},
					{
						name: 'search_candidate_assessment',
						id: 'search-candidate-assessment'
					},
				]
			},

			// _____________ Email Templates ______________
			{
				name: 'email_templates',
				id: 'email-templates',
				types: [
					{
						name: 'create_template',
						id: 'create-template',
					},
					{
						name: 'edit_template',
						id: 'edit-template'
					},
					{
						name: 'delete_template',
						id: 'delete-template'
					},
					{
						name: 'get_all_template',
						id: 'get-all-template'
					},
				]
			},

			// _____________Entity _______________
			{
				name: 'entity',
				id: 'entity',
				types: [
					{
						name: 'create_entity',
						id: 'create-entity',
					},
					{
						name: 'edit_entity',
						id: 'edit-entity'
					},
					{
						name: 'delete_entity',
						id: 'delete-entity'
					},
					{
						name: 'get_all_entitys',
						id: 'get-all-entitys'
					},
					{
						name: 'get_entites_by_entity_group',
						id: 'get-entites-by-entity-group'
					},
				]
			},

			// __________ Entity Group _______________
			{
				name: 'entity_group',
				id: 'entity-group',
				types: [
					{
						name: 'create_entity_group',
						id: 'create-entity-group',
					},
					{
						name: 'edit_entity_group',
						id: 'edit-entity-group'
					},
					{
						name: 'delete_entity_group',
						id: 'delete-entity-group'
					},
					{
						name: 'get_all_entitys_group',
						id: 'get-all-entitys-group'
					},
				]
			},

			// ______________ Evaluations ____________
			{
				name: 'evaluation',
				id: 'evaluation',
				types: [
					{
						name: 'create_evaluation',
						id: 'create-evaluation',
					},
					{
						name: 'edit_evaluation',
						id: 'edit-evaluation'
					},
					{
						name: 'delete_evaluation',
						id: 'delete-evaluation'
					},
					{
						name: 'get_all_evaluation',
						id: 'get-all-evaluation'
					},
					{
						name: 'create_bulk_evaluations',
						id: 'create-bulk-evaluations'
					},
					{
						name: 'update_bulk_evaluations',
						id: 'update-bulk-evaluations'
					},
					// {
					// 	name: 'search_evaluation',
					// 	id: 'search-evaluation'
					// },
				]
			},

			// ______________Events  ______________
			{
				name: 'event',
				id: 'event',
				types: [
					{
						name: 'create_event',
						id: 'create-event',
					},
					{
						name: 'event_by_candidate',
						id: 'event-by-candidate'
					},
					{
						name: 'edit_event',
						id: 'edit-event'
					},
					{
						name: 'delete_event',
						id: 'delete-event'
					},
					{
						name: 'get_all_event',
						id: 'get-all-event'
					},
					{
						name: 'create_bulk_events',
						id: 'create-bulk-events'
					},
					{
						name: 'create_candidate_bulk_events',
						id: 'create-candidate-bulk-events'
					},
				]
			},

			// ___________ Features _____________
			{
				name: 'features',
				id: 'features',
				types: [
					{
						name: 'create_features',
						id: 'create-features',
					},
					{
						name: 'edit_features',
						id: 'edit-features'
					},
					{
						name: 'delete_features',
						id: 'delete-features'
					},
					{
						name: 'get_all_features',
						id: 'get-all-features'
					},
				]
			},

			// ______________ General _____________
			// {
			// 	name: 'general',
			// 	id: 'general',
			// 	types: [
			// 		{
			// 			name: 'test_upload_speed',
			// 			id: 'test-upload-speed',
			// 		},
			// 		{
			// 			name: 'upload_image',
			// 			id: 'upload-image'
			// 		},
			// 		{
			// 			name: 'upload_resume',
			// 			id: 'upload-resume'
			// 		},
			// 		{
			// 			name: 'upload_video',
			// 			id: 'upload-video'
			// 		},
			// 		{
			// 			name: 'upload_file',
			// 			id: 'upload-file'
			// 		},
			// 		{
			// 			name: 'recognition',
			// 			id: 'recognition'
			// 		},
			// 	]
			// },

			// ______________Instructors_____________
			{
				name: 'instructor',
				id: 'instructor',
				types: [
					{
						name: 'create_instructor',
						id: 'create-instructor',
					},
					{
						name: 'edit_instructor',
						id: 'edit-instructor'
					},
					{
						name: 'delete_instructor',
						id: 'delete-instructor'
					},
					{
						name: 'get_all_instructors',
						id: 'get-all-instructors'
					},
				]
			},

			// ______________Instructor Activity_____________
			{
				name: 'instructor_activity',
				id: 'instructor-activity',
				types: [
					{
						name: 'get_instructor_activity',
						id: 'get-instructor-activity'
					},
					{
						name: 'create_instructor_activity',
						id: 'create-instructor-activity',
					},
					{
						name: 'edit_instructor_activity',
						id: 'edit-instructor-activity'
					},
					{
						name: 'delete_instructor_activity',
						id: 'delete-instructor-activity'
					},
					{
						name: 'search_instructor_activity',
						id: 'search-instructor-activity'
					},
				]
			},

			// ___________ Invitations _______________
			{
				name: 'invitations',
				id: 'invitations',
				types: [
					{
						name: 'create_invite',
						id: 'create-invite',
					},
					{
						name: 'search_invite',
						id: 'search-invite'
					},
					{
						name: 'delete_invite',
						id: 'delete-invite'
					},
					{
						name: 'get_all_invites',
						id: 'get-all-invites'
					},
					{
						name: 'send_reminder',
						id: 'send-reminder'
					},
					{
						name: 'bulk_invitation_last_date_update',
						id: 'bulk-invitation-last-date-update'
					},
					{
						name: 're_invite',
						id: 're-invite'
					}
				]
			},

			// _____________ Notification ______________
			{
				name: 'notification',
				id: 'notification',
				types: [
					{
						name: 'create_notification',
						id: 'create-notification',
					},
					{
						name: 'edit_notification',
						id: 'edit-notification'
					},
					{
						name: 'delete_notification',
						id: 'delete-notification'
					},
					{
						name: 'get_all_notification',
						id: 'get-all-notification'
					},
				]
			},

			// ______________Panels ___________________
			{
				name: 'panel',
				id: 'panel',
				types: [
					{
						name: 'create_panel',
						id: 'create-panel',
					},
					{
						name: 'edit_panel',
						id: 'edit-panel'
					},
					{
						name: 'delete_panel',
						id: 'delete-panel'
					},
					{
						name: 'search_panel',
						id: 'search-panel'
					},
					{
						name: 'duplicate_panel',
						id: 'duplicate-panel'
					},
					{
						name: 'panel_with_sessions',
						id: 'panel-with-sessions'
					},
					{
						name: 'edit_panel_with_sessions',
						id: 'edit-panel-with-sessions'
					},
					{
						name: 'get_all_panels',
						id: 'get-all-panels'
					},
				]
			},

			// ____________Playlist______________
			{
				name: 'playlist',
				id: 'playlist',
				types: [
					{
						name: 'create_playlist',
						id: 'create-playlist',
					},
					{
						name: 'edit_playlist',
						id: 'edit-playlist'
					},
					{
						name: 'delete_playlist',
						id: 'delete-playlist'
					},
					{
						name: 'search_playlist',
						id: 'search-playlist'
					},
					{
						name: 'duplicate_playlist',
						id: 'duplicate-playlist'
					},
					{
						name: 'playlist_with_sessions',
						id: 'playlist-with-sessions'
					},
					{
						name: 'edit_playlist_with_sessions',
						id: 'edit-playlist-with-sessions'
					},
					{
						name: 'get_all_playlists',
						id: 'get-all-playlists'
					},
				]
			},

			// ____________ Feature Set / Role ____________
			{
				name: 'role',
				id: 'role',
				types: [
					{
						name: 'create_role',
						id: 'create-role',
					},
					{
						name: 'edit_role',
						id: 'edit-role'
					},
					{
						name: 'delete_role',
						id: 'delete-role'
					},
					{
						name: 'get_all_role',
						id: 'get-all-role'
					},
				]
			},

			// ____________ Report Delivery ____________
			{
				name: 'report_delivery',
				id: 'report-delivery',
				types: [
					{
						name: 'get_all_report_delivery',
						id: 'get-all-report-delivery'
					},
					{
						name: 'create_report_delivery',
						id: 'create-report-delivery',
					},
					{
						name: 'edit_report_delivery',
						id: 'edit-report-delivery'
					},
					{
						name: 'delete_report_delivery',
						id: 'delete-report-delivery'
					},
				]
			},

			// ____________ School ____________
			{
				name: 'school',
				id: 'school',
				types: [
					{
						name: 'create_school',
						id: 'create-school',
					},
					{
						name: 'edit_school',
						id: 'edit-school'
					},
					{
						name: 'delete_school',
						id: 'delete-school'
					},
					{
						name: 'get_all_school',
						id: 'get-all-school'
					},
				]
			},

			// ____________ Sections ____________
			{
				name: 'section',
				id: 'section',
				types: [
					{
						name: 'get_section',
						id: 'get-section'
					},
					{
						name: 'create_section',
						id: 'create-section',
					},
					{
						name: 'edit_section',
						id: 'edit-section'
					},
					{
						name: 'delete_section',
						id: 'delete-section'
					},
					{
						name: 'get_section_by_candidate',
						id: 'get-section-by-candidate'
					},
				]
			},

			// ___________Section Sessions _____________
			{
				name: 'section_sessions',
				id: 'section-sessions',
				types: [
					{
						name: 'create_section_session',
						id: 'create-section-session',
					},
					{
						name: 'edit_section_session',
						id: 'edit-section-session'
					},
					{
						name: 'delete_section_session',
						id: 'delete-section-session'
					},
					{
						name: 'search_section_session',
						id: 'search-section-session'
					},
					{
						name: 'get_all_section_session',
						id: 'get-all-section-session'
					},
					{
						name: 'create_candidate_section_session',
						id: 'create-candidate-section-session'
					},
					{
						name: 'candidate_edit_section_session',
						id: 'candidate-edit-section-session'
					},
					{
						name: 'get_or_create_section_session',
						id: 'get-or-create-section-session'
					},
				]
			},

			// ___________ Secure feature Profile__________
			{
				name: 'secure_feature_profile',
				id: 'secure-feature-profile',
				types: [
					{
						name: 'create_profile',
						id: 'create-profile',
					},
					{
						name: 'edit_profile',
						id: 'edit-profile'
					},
					{
						name: 'delete_profile',
						id: 'delete-profile'
					},
					{
						name: 'get_all_profiles',
						id: 'get-all-profiles'
					},
				]
			},
		]
	}
];

export const DASHBOARD_ARTICLE_CONTENT = [
	{
		portal: 'dashboard_api',
		description: 'dashboard_endpoints_api_description',
		content: [
			// _______________ Authentication _________________
			{
				id: 'authentication',
				heading: 'authentication',
				groupDescription: 'authentication_group_description',
				subSections: [
					{
						id: 'login',
						heading: 'Login',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/token/',
						description: ['login_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'password',
									type: 'string',
									description: 'password_param_description'
								}
							]
						},
						requestObject: {
							id: 'login',
							method: "POST",
							endpoint: "/auth/token/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								email: 'john.doe@example.com',
								password: '****'
							}
						},
					},
					{
						id: 'forgot-password',
						heading: 'forgot_password',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/forget_password/',
						description: ['forgot_password_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								}
							]
						},
						requestObject: {
							id: 'forgot-password',
							method: "POST",
							endpoint: "/auth/forget_password/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								email: 'john.doe@example.com',
							}
						},
					},
					{
						id: 'change-password',
						heading: 'change_password',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/change-passowrd/',
						description: ['change_password_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'uid',
									type: 'string',
									description: 'uid_param_description'
								},
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
								{
									parameter: 'password',
									type: 'string',
									description: 'password_param_description'
								}
							]
						},
						requestObject: {
							id: 'forgot-password',
							method: "POST",
							endpoint: "/auth/change-passowrd/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								uuid: 'special characters',
								token: 'special characters',
								password: '********'
							}
						},
					},
					// {
					// 	id: 'candidate-token',
					// 	heading: 'candidate_token',
					// 	httpRequest: 'POST https://dashboard-api.mereos.eu/auth/candidate_token/',
					// 	description: ['candidate_token_decription'],
					// 	table: {
					// 		columns: [
					// 			{
					// 				heading: `${'parameter'}`,
					// 				accessor: 'parameter'
					// 			},
					// 			{
					// 				heading: `${'type'}`,
					// 				accessor: 'type'
					// 			},
					// 			{
					// 				heading: `${'description'}`,
					// 				accessor: 'description'
					// 			},
					// 		],
					// 		data: [
					// 			{
					// 				parameter: 'exam_code',
					// 				type: 'string',
					// 				description: 'exam_code_param_description'
					// 			},
					// 			{
					// 				parameter: 'candidate_invite_assessment_id',
					// 				type: 'string',
					// 				description: 'candidate_invite_assessment_id'
					// 			}
					// 		]
					// 	},
					// 	requestObject: {
					// 		id: 'login',
					// 		method: "POST",
					// 		endpoint: "/auth/candidate_token/",
					// 		host: "https://dashboard-api.mereos.eu",
					// 		contentType: "application/json",
					// 		body: {
					// 			"exam_code": "abc-def-123-456",
					// 			"candidate_invite_assessment_id": 123
					// 		}
					// 	},
					// },
					{
						id: 'me',
						heading: 'user_information',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/me/',
						description: ['me_api_description'],
						requestObject: {
							id: 'login',
							method: "POST",
							endpoint: "/auth/me/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
						},
					},
					{
						id: 'google-api-login',
						heading: 'google_api_login',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/google_login_api/',
						description: ['google_api_login_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'google-api-login',
							method: "POST",
							endpoint: "/auth/google_login_api/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'send-otp',
						heading: 'send_otp',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/send_otp/',
						description: ['send_otp_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
							]
						},
						requestObject: {
							id: 'send-otp',
							method: "POST",
							endpoint: "/auth/send_otp/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"email": "john.doe@example.com"
							}

						},
					},
					{
						id: 'verify-otp',
						heading: 'verify_otp',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/verify_otp/',
						description: ['verify_otp_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'code',
									type: 'string',
									description: 'code_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-otp',
							method: "POST",
							endpoint: "/auth/verify_otp/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"email": "john.doe@example.com",
								"code": "******"
							}
						},
					},
					{
						id: 'login-with-microsoft-entra',
						heading: 'login_with_microsoft_entra',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/login_with_microsoft_entra/',
						description: ['login_with_microsoft_entra_description', 'login_with_microsoft_entra_description2'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'object',
									description: 'microsoft_entra_token_param_description'
								},
							]
						},
						requestObject: {
							id: 'login-with-microsoft-entra',
							method: "POST",
							endpoint: "/auth/login_with_microsoft_entra/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"token": {
									"authority": "https://login.microsoftonline.com/common/",
									"accessToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6...(truncated)",
									"idToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6...(truncated)",
									"idTokenClaims": {
										"aud": "754bcf92-ae3b-4f18-84ea-ab67be8c2063",
										"iss": "https://login.microsoftonline.com/{tenant-id}/v2.0",
										"name": "John Doe",
										"preferred_username": "john.doe@example.onmicrosoft.com",
										"oid": "00000000-0000-0000-0000-000000000000",
										"tid": "00000000-0000-0000-0000-000000000000"
									},
									"account": {
										"homeAccountId": "00000000-0000-0000-0000-000000000000.00000000-0000-0000-0000-000000000000",
										"environment": "login.windows.net",
										"tenantId": "00000000-0000-0000-0000-000000000000",
										"username": "john.doe@example.onmicrosoft.com",
										"localAccountId": "00000000-0000-0000-0000-000000000000",
										"name": "John Doe"
									},
									"scopes": ["openid", "profile", "email", "Group.Read.All", "User.Read"],
									"tokenType": "Bearer",
									"expiresOn": "2026-08-06T13:21:45.000Z",
									"tenantId": "00000000-0000-0000-0000-000000000000",
									"uniqueId": "00000000-0000-0000-0000-000000000000"
								}
							}
						},
					},
				]
			},

			// _______________ 2FA Authentication _________________
			{
				id: '2fa-authentication',
				heading: '2fa_authentication',
				groupDescription: '2fa_authentication_group_description',
				subSections: [
					{
						id: 'generate-2fa',
						heading: 'generate_2fa',
						httpRequest: 'GET https://dashboard-api.mereos.eu/auth/generate_2fa/',
						description: ['generate_2fa_api_description'],
						requestObject: {
							id: 'generate-2fa',
							method: "GET",
							endpoint: "/auth/generate_2fa/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
						},
					},
					{
						id: 'verify-2fa',
						heading: 'verify_2fa',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/verify_2fa/',
						description: ['verify_2fa_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-2fa',
							method: "POST",
							endpoint: "/auth/verify_2fa/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'verify-2fa-login',
						heading: 'verify_2fa_login',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/verify_2fa_login/',
						description: ['verify_2fa_login_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'token',
									type: 'string',
									description: 'token_param_description'
								},
							]
						},
						requestObject: {
							id: 'verify-2fa-login',
							method: "POST",
							endpoint: "/auth/verify_2fa_login/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"token": "*****"
							}
						},
					},
					{
						id: 'check-2fa',
						heading: 'check_2fa',
						httpRequest: 'GET https://dashboard-api.mereos.eu/auth/check_2fa/',
						description: ['check_2fa_api_description'],
						requestObject: {
							id: 'check-2fa',
							method: "GET",
							endpoint: "/auth/check_2fa/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
						},
					},
					{
						id: 'change-2fa-status',
						heading: 'change_2fa_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/auth/change_2fa_status/',
						description: ['change_2fa_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'is_enabled',
									type: 'boolean',
									description: 'is_enabled_param_description'
								},
							]
						},
						requestObject: {
							id: 'change-2fa-status',
							method: "POST",
							endpoint: "/auth/change_2fa_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"is_enabled": true
							}
						},
					},
				]
			},

			// _____________ AI Events _______________
			{
				id: 'ai-events',
				heading: 'ai_events',
				groupDescription: 'ai_events_group_description',
				subSections: [
					{
						id: 'create-ai_events',
						heading: 'create_ai_events',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/ai_event/',
						description: ['create_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									optional: true,
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-template',
							method: "POST",
							endpoint: "/section_session/ai_event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Testing Post",
								"value": "Testing Post",
								"section_session": 405,
								"created_at": "2024-03-07T11:20:02.411207Z",
								"start_at": "2024-03-07T11:20:02.411207Z",
								"end_at": "2024-03-07T11:20:02.411207Z",
							}
						},
					},
					{
						id: 'create-ai_events-by-candiates',
						heading: 'ai_events_by_candidate',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/post_ai_events/',
						description: ['create_ai_event_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									optional: true,
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-ai_events-by-candiates',
							method: "POST",
							endpoint: "/section_session/post_ai_events/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Testing Post",
								"value": "Testing Post",
								"section_session": 405,
								"created_at": "2024-03-07T11:20:02.411207Z",
								"start_at": "2024-03-07T11:20:02.411207Z",
								"end_at": "2024-03-07T11:20:02.411207Z",
							}
						},
					},
					{
						id: 'edit-ai_events',
						heading: 'edit_ai_events',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/ai_event/',
						description: ['edit_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									optional: true,
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-ai_events',
							method: "PUT",
							endpoint: "/section_session/ai_event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "Testing Post",
								"value": "Testing Post",
								"section_session": 405,
								"created_at": "2024-03-07T11:20:02.411207Z",
								"start_at": "2024-03-07T11:20:02.411207Z",
								"end_at": "2024-03-07T11:20:02.411207Z",
							}
						},
					},
					{
						id: 'delete-ai_events',
						heading: 'delete_ai_events',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/ai_event/?id=2',
						description: ['delete_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-ai_events',
							method: "DELETE",
							endpoint: "/section_session/ai_event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 2
							}
						}
					},
					{
						id: 'get-all-ai_events',
						heading: 'get_all_ai_events',
						httpRequest: 'GET https://dashboard-api.mereos.eu/section_session/ai_event/?page=1&range=1',
						description: ['all_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-ai_events',
							method: "GET",
							endpoint: "/section_session/ai_event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								page: 1,
								range: 1
							}
						},
					},
					{
						id: 'bulk-ai-events',
						heading: 'bulk_ai_events',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/bulk_ai_events/',
						description: ['bulk_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'ai_events',
									type: 'array',
									description: 'ai_events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									optional: true,
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'bulk-ai_events',
							method: "POST",
							endpoint: "/section_session/bulk_ai_events/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"ai_events": [
									{
										"name": "event1",
										"value": "123",
										"section_session": 135,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"section_session": 135,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					},
					{
						id: 'candidate-bulk-ai-events',
						heading: 'candidate_bulk_ai_events',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/candidate_bulk_ai_events/',
						description: ['candidate_bulk_ai_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'ai_events',
									type: 'array',
									description: 'ai_events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									optional: true,
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'candidate-bulk-ai_events',
							method: "POST",
							endpoint: "/section_session/candidate_bulk_ai_events/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"ai_events": [
									{
										"name": "event1",
										"value": "123",
										"section_session": 441,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"section_session": 441,
										"start_at": "2025-08-28T14:00:00Z",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					},
				]
			},

			// ___________________ Alerts _________________
			{
				id: 'alert',
				heading: 'alert',
				groupDescription: 'alert_group_description',
				subSections: [
					{
						id: 'create-alert',
						heading: 'create_alert',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/alert/',
						description: ['create_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'read_at',
									optional: true,
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'alert_type',
									optional: true,
									type: 'string',
									description: 'alert_type_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-evaluation',
							method: "POST",
							endpoint: "/role/alert/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"body": { "html": "Hello World!", "delta": [] },
								"read_at": "2024-04-23T08:16:54.925262Z",
								"modify_at": "2024-04-23T08:16:54.925262Z",
								"created_at": "2024-04-23T08:16:54.925305Z",
								"alert_type": 2,
								"instructor": 12
							}
						},
					},
					{
						id: 'edit-alert',
						heading: 'edit_alert',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/alert/',
						description: ['edit_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'body',
									optional: true,
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'read_at',
									optional: true,
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'alert_type',
									optional: true,
									type: 'string',
									description: 'alert_type_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-alert',
							method: "PUT",
							endpoint: "/role/alert/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 109,
								"body": { "html": "Hello World!", "delta": [] },
								"read_at": "2024-04-23T08:16:54.925262Z",
								"modify_at": "2024-04-23T08:16:54.925262Z",
								"created_at": "2024-04-23T08:16:54.925305Z",
								"alert_type": 2
							}
						},
					},
					{
						id: 'delete-alert',
						heading: 'delete_alert',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/alert/?id=3',
						description: ['delete_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-alert',
							method: "DELETE",
							endpoint: "/role/alert/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 3
							}
						}
					},
					{
						id: 'get-all-alert',
						heading: 'get_all_alert',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/alert/',
						description: ['all_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-ai_events',
							method: "GET",
							endpoint: "/role/alert/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'search-alert',
						heading: 'search_alert',
						httpRequest: `GET https://dashboard-api.mereos.eu/role/alert_search/?search=&page=1&range=1&q=Q(alert_type__id=2)&$expand=instructor&attach=alert_type&unattach=body`,
						description: ['search_alert_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'search-alert',
							method: "GET",
							endpoint: "/role/alert_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "",
								page: 1,
								range: 1,
								q: "Q(alert_type__id=2)",
								$expand: "instructor",
								attach: "alert_type",
								unattach: "body"
							}
						},
					},
					{
						id: 'bulk-edit-alert',
						heading: 'bulk_edit_alert',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/bulk_update_alerts/',
						description: ['bulk_edit_alert_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'array',
									description: 'id_param_description'
								},
								{
									parameter: 'read_at',
									optional: true,
									type: 'date',
									description: 'read_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-alert',
							method: "PUT",
							endpoint: "/role/bulk_update_alerts/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": [2, 4],
								"read_at": "12/12/12 12:12:12"
							}
						},
					},
				]
			},

			// ___________________ Alert Types _______________
			{
				id: 'alert-types',
				heading: 'alert_types',
				groupDescription: 'alert_types_group_description',
				subSections: [
					{
						id: 'create-alert-types',
						heading: 'create_alert_type',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/alert_type/',
						description: ['create_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-instructor',
							method: "POST",
							endpoint: "/role/alert_type/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"name": "test 1",
								"description": "test 1",
								"modify_at": "2024-04-23T07:51:54.242141Z",
								"created_at": "2024-04-23T07:51:54.242181Z"
							}
						},
					},
					{
						id: 'edit-alert-types',
						heading: 'edit_alert_type',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/alert_type/',
						description: ['edit_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/role/alert_type/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "test 1 Updated",
								"description": "test 1 updated",
								"modify_at": "2024-04-23T07:53:46.134108Z",
								"created_at": "2024-04-23T07:53:46.134265Z"
							}
						},
					},
					{
						id: 'delete-alert-types',
						heading: 'delete_alert_types',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/alert_type/?id=3',
						description: ['delete_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-instructor',
							method: "DELETE",
							endpoint: "/role/alert_type/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								id: 3
							}
						}
					},
					{
						id: 'get-all-alert-types',
						heading: 'get_all_alert_types',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/alert_type/?page=1&range=1',
						description: ['all_alert_type_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-notification',
							method: "GET",
							endpoint: "/role/alert_type/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								page: 1,
								range: 1
							}
						},
					},
				]
			},

			// ___________________ Analytics _______________
			{
				id: 'analytics',
				heading: 'analytics',
				groupDescription: 'analytics_group_description',
				subSections: [
					{
						id: 'user-conversion',
						heading: 'user_conversion',
						httpRequest: 'POST https://dashboard-api.mereos.eu/analytics/user_conversion/',
						description: ['user_conversion_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									optional: true,
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'assessment',
									optional: true,
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'user-conversion',
							method: "POST",
							endpoint: "/analytics/user_conversion/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"start_at": "2025-01-13T00:00:00.000Z",
								"end_at": "2025-05-12T23:59:59.999Z",
								"instructor": 12,
								"assessment": 857
							}
						},
					},
					{
						id: 'playlist-conversion-count-and-time',
						heading: 'playlist_conversion_count_and_time',
						httpRequest: 'POST https://dashboard-api.mereos.eu/analytics/playlist_conversion_count_and_time/',
						description: ['playlist_conversion_count_and_time_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'playlist',
									optional: true,
									type: 'integer',
									description: 'playlist_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'playlist-conversion-count-and-time',
							method: "POST",
							endpoint: "/analytics/playlist_conversion_count_and_time/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"start_at": "2024-04-25T19:00:00.000Z",
								"end_at": "2024-05-01T19:00:00.000Z",
								"playlist": 5
							}
						},
					},
					{
						id: 'create-assessment-time-to-process',
						heading: 'create_assessment_time_to_process',
						httpRequest: 'POST https://dashboard-api.mereos.eu/analytics/assessment_time_to_process/',
						description: ['create_assessment_time_to_process_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-assessment-time-to-process',
							method: "POST",
							endpoint: "/analytics/assessment_time_to_process/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"start_at": "2024-04-25T19:00:00.000Z",
								"end_at": "2024-05-01T19:00:00.000Z"
							}
						},
					},
					{
						id: 'average-score',
						heading: 'average_score',
						httpRequest: 'POST https://dashboard-api.mereos.eu/analytics/average_score/',
						description: ['average_score_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'average-score',
							method: "POST",
							endpoint: "/analytics/average_score/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"start_at": "2024-04-25T19:00:00.000Z",
								"end_at": "2024-05-01T19:00:00.000Z"
							}
						},
					},
					{
						id: 'average-time-spent-on-item',
						heading: 'average_time_spent_on_item',
						httpRequest: 'POST https://dashboard-api.mereos.eu/analytics/average_time_on_solving_item/',
						description: ['average_time_spent_on_item_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'string',
									description: 'id_param_description'
								},
								{
									parameter: 'type',
									optional: true,
									type: 'string',
									description: 'type_param_description'
								},
								{
									parameter: 'display_time_spent',
									optional: true,
									type: 'boolean',
									description: 'display_time_spent_for_average_time_spent_on_item_description'
								},
								{
									parameter: 'display_item_numbers',
									optional: true,
									type: 'boolean',
									description: 'display_item_numbers_for_average_time_spent_on_item_description'
								},
								{
									parameter: 'scoring_type',
									optional: true,
									type: 'string',
									description: 'scoring_type_for_average_time_spent_on_item_description'
								},
								{
									parameter: 'users',
									optional: true,
									type: 'array',
									description: 'users_for_average_time_spent_on_item_description'
								},
								{
									parameter: 'activity_id',
									optional: true,
									type: 'string',
									description: 'activity_id_for_average_time_spent_on_item_description'
								}
							]
						},
						requestObject: {
							id: 'average-time-spent-on-item',
							method: "POST",
							endpoint: "/analytics/average_time_on_solving_item/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"id": "report-5",
								"type": "lastscore-by-item-by-user",
								"display_time_spent": true,
								"display_item_numbers": true,
								"scoring_type": "partial",
								"users": [
									{
										"id": "448",
										"name": "John Doe"
									},
									{
										"id": "John Doe",
										"name": "Student 004"
									}
								],
								"activity_id": "211c79be-cfd5-40e7-826c-33c4dcfcf854"
							}
						},
					},
					{
						id: 'dashboard-stats',
						heading: 'dashboard_stats',
						httpRequest: 'GET https://dashboard-api.mereos.eu/analytics/dashboard_stats/',
						description: ['dashboard_stats_api_description'],
						requestObject: {
							id: 'dashboard-stats',
							method: "GET",
							endpoint: "/analytics/dashboard_stats/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
						},
					},
				]
			},

			// ---------------- Assessment ---------------
			{
				id: 'assessment',
				heading: 'assessment',
				groupDescription: 'assessment_group_description',
				subSections: [
					{
						id: 'create-assessment',
						heading: 'create_assessment',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/assessment',
						description: ['create_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'owner',
									optional: true,
									type: 'integer',
									description: 'owner_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'status',
									optional: true,
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-assessment',
							method: "POST",
							endpoint: "/assessment/assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"owner": 12,
								"name": "doorbell2234",
								"description": "doorbell2234",
								"external_id": "",
								"status": "Draft",
								"end_at": "2028-06-07T11:53:34Z",
								"start_at": "2020-02-24T11:53:35Z"
							}
						},
					},
					{
						id: 'edit-assessment',
						heading: 'edit_assessment',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/assessment',
						description: ['edit_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									optional: true,
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'owner',
									optional: true,
									type: 'integer',
									description: 'owner_param_description'
								},
								{
									parameter: 'section',
									optional: true,
									type: 'array',
									description: 'section_param_description'
								},
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'assessment_link',
									optional: true,
									type: 'url',
									description: 'assessment_link_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									optional: true,
									type: 'integer',
									description: 'school_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-assessment',
							method: "PUT",
							endpoint: "/assessment/assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 831,
								"status": "Opened",
								"owner": 29,
								"section": [],
								"name": "John Doe",
								"description": "Random Description",
								"external_id": "my external_id",
								"end_at": "2024-01-31T13:27:00Z",
								"start_at": "2023-03-07T13:27:00Z",
								"assessment_link": "https://candidate.mereos-datasafe.com/registration/332/",
								"created_at": "2023-10-26T11:34:34.909363Z",
								"school": 1
							}
						},
					},
					{
						id: 'delete-assessment',
						heading: 'delete_assessment',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/assessment/assessment/?id=631',
						description: ['delete_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-assessment',
							method: "DELETE",
							endpoint: "/assessment/assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 631
							}
						}
					},
					{
						id: 'search-assessment',
						heading: 'search_assessment',
						httpRequest: `GET https://dashboard-api.mereos.eu/assessment/assessment_search/?search=601&page=2&range=25&including_columns=owner&q=Q(created_at='2024-07-31T12:34:56')&$expand=owner&attach=candidate_assessments&unattach=activity`,
						description: ['search_assessment_api_description', 'search_assessment_api_description2', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'search-assessment',
							method: "GET",
							endpoint: "/assessment/assessment_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "601",
								page: 2,
								range: 25,
								including_columns: "owner",
								q: "Q(created_at='2024-07-31T12:34:56')",
								$expand: "owner",
								attach: "candidate_assessments",
								unattach: "activity"
							}
						},
					},
					{
						id: 'duplicate-assessment',
						heading: 'duplicate_assessment',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/duplicate_assessment/',
						description: ['duplicate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'assessment_name',
									type: 'string',
									description: 'assessment_name_param_description'
								},
								{
									parameter: 'duplicate_items',
									optional: true,
									type: 'boolean',
									description: 'duplicate_items_for_duplicate_assessment_description'
								},
								{
									parameter: 'duplicate_activity',
									optional: true,
									type: 'boolean',
									description: 'duplicate_activity_for_duplicate_assessment_description'
								},
								{
									parameter: 'duplicate_secure_feature_profile',
									optional: true,
									type: 'boolean',
									description: 'duplicate_secure_feature_profile_for_duplicate_assessment_description'
								}
							]
						},
						requestObject: {
							id: 'duplicate-assessment',
							method: "POST",
							endpoint: "/assessment/duplicate_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 1303,
								"assessment_name": "keys are null",
								"duplicate_items": false,
								"duplicate_activity": true,
								"duplicate_secure_feature_profile": false
							}
						}
					},
					{
						id: 'change-assessment-date',
						heading: 'change_assessment_date',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/change_assessment_date/',
						description: ['change_assessment_date_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment_id',
									type: 'integer',
									description: 'assessment_id_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'notify',
									optional: true,
									type: 'boolean',
									description: 'notify_param_description'
								}
							]
						},
						requestObject: {
							id: 'change-assessment-date',
							method: "POST",
							endpoint: "/assessment/change_assessment_date/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"start_at": "2025-10-29T10:31:00.000Z",
								"end_at": "2026-09-08T07:23:00.000Z",
								"assessment_id": 1468,
								"notify": true
							}
						}
					},
					{
						id: 'get-all-assessments',
						heading: 'get_all_assessments',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/assessment/?$expand=owner&id=895&name__icontains=QA Assessment - T002&description=Some Text&status__name=opened&school=34&page=1&range=1&external_id__isnull=False&attach=candidate_assessments&unattach=activity&$expand=owner, activity',
						description: ['all_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name__icontains',
									optional: true,
									type: 'string',
									description: 'name__icontains_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'status__name',
									optional: true,
									type: 'string',
									description: 'status_name_for_get_all_assessments_description'
								},
								{
									parameter: 'school',
									optional: true,
									type: 'string',
									description: 'school_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'external_id__isnull',
									optional: true,
									type: 'boolean',
									description: 'external_id_isnull_for_get_all_assessments_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-assessments',
							method: "GET",
							endpoint: "/assessment/assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								$expand: "owner, activity",
								id: 895,
								name__icontains: "QA Assessment - T002",
								description: "Some Text",
								status__name: "opened",
								school: 34,
								page: 1,
								range: 1,
								external_id__isnull: false,
								attach: "candidate_assessments",
								unattach: "activity"
							}
						},
					},
					{
						id: 'post-assessment-with-section',
						heading: 'post_assessment_with_section',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/assessment_with_section/',
						description: ['post_assessment_with_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'sections',
									optional: true,
									type: 'array',
									description: 'sections_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'post-assessment-with-section',
							method: "POST",
							endpoint: "/assessment/assessment_with_section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "py-gen",
								"description": "py-gen assessment",
								"sections": [
									{
										"allow_interruption": true,
										"name": "py-gen1"
									},
									{
										"allow_interruption": false,
										"name": "py-gen2"
									},
									{
										"allow_interruption": false,
										"name": "py-gen3"
									}
								],
								"external_id": "kwgrinlweiuwnelfj",
								"start_at": "2025-03-21T15:38",
								"end_at": "2026-03-21T15:38"
							}
						}
					},
					{
						id: 'update-assessment-with-section',
						heading: 'update_assessment_with_section',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/update_assessments_with_sections/',
						description: ['update_assessment_with_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'owner',
									optional: true,
									type: 'integer',
									description: 'owner_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'section',
									optional: true,
									type: 'array',
									description: 'section_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'status',
									optional: true,
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'assessment_link',
									optional: true,
									type: 'string',
									description: 'assessment_link_param_description'
								}
							]
						},
						requestObject: {
							id: 'upload-assessment-with-section',
							method: "PUT",
							endpoint: "/assessment/update_assessments_with_sections/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 1435,
								"name": "big data",
								"owner": 12,
								"description": "Random Description",
								"section": [
									{
										"secure_feature_profile": null,
										"questions": [],
										"name": "John Doe",
										"activity": "0863d864-57eb-4549-a5be-92f79f4e7b8b",
										"allow_interruption": true,
										"assessment": 1435
									},
									{
										"secure_feature_profile": null,
										"questions": [],
										"name": "John Doe1",
										"activity": "02e362ff-8386-4a26-ba9a-8f9259ab5326",
										"allow_interruption": false,
										"assessment": 1435
									},
								],
								"external_id": null,
								"status": "Draft",
								"end_at": "2026-04-19T12:39:00+05:00",
								"start_at": "2025-12-09T13:40:00+05:00",
								"assessment_link": "https://mereos.page.link/K9de",
							}
						}
					},
					{
						id: 'public-assessment',
						heading: 'public_assessment',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/public_assessment/?assessment_id=773',
						description: ['public_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment_id',
									optional: true,
									type: 'integer',
									description: 'assessment_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'public-assessment',
							method: "GET",
							endpoint: "/assessment/public_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								assessment_id: 773
							}
						}
					},
				]
			},

			// __________________ Assessment Reports _________________
			{
				id: 'assessment-report',
				heading: 'assessment_report',
				groupDescription: 'assessment_report_group_description',
				subSections: [
					{
						id: 'create-report',
						heading: 'create_report',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_report/',
						description: ['create_assessment_report_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'candidate_assessment',
									optional: true,
									type: 'integer',
									description: 'candidate_assessment_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'reports',
									optional: true,
									type: 'array',
									description: 'reports_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-report',
							method: "POST",
							endpoint: "/candidate/candidate_assessment_report/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"candidate_assessment": 767,
								"instructor": 12,
								"description": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"reports": {
									"reports": [
										{
											solution: '',
											file: 'binary'
										}
									]
								}
							}
						},
					},
					{
						id: 'edit-report',
						heading: 'edit_report',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/candidate_assessment_report/',
						description: ['edit_assessment_report_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									optional: true,
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'reports',
									optional: true,
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-report',
							method: "PUT",
							endpoint: "/candidate/candidate_assessment_report/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 21,
								"description": "",
								"reports": [
									{
										"id": "3",
										"files": "",
										"solutions": "Fraud"
									}
								],
								"modify_at": "2025-01-01T06:19:33.091491Z",
								"created_at": "2025-01-01T06:19:33.091505Z",
								"instructor": 12
							}
						},
					},
					{
						id: 'delete-report',
						heading: 'delete_report',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/candidate/candidate_assessment_report/?id=4',
						description: ['delete_assessment_report_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-report',
							method: "DELETE",
							endpoint: "/candidate/candidate_assessment_report/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-report',
						heading: 'get_all_report',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_report/?page=1&range=1&$expand=instructor',
						description: ['all_assessment_report_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-report',
							method: "GET",
							endpoint: "/candidate/candidate_assessment_report/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								page: 1,
								range: 1,
								$expand: "instructor"
							}
						},
					},
				]
			},

			// _______________ Assessment Status _________________
			{
				id: 'assessment-status',
				heading: 'assessment_status',
				groupDescription: 'assessment_status_group_description',
				subSections: [
					{
						id: 'create-assessment-status',
						heading: 'create_assessment_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/assessment_status/',
						description: ['create_assessment_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-assessment-status',
							method: "POST",
							endpoint: "/assessment/assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Draft"
							}
						},
					},
					{
						id: 'edit-assessment-status',
						heading: 'edit_assessment_status',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/assessment_status/',
						description: ['edit_assessment_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-assessment-status',
							method: "PUT",
							endpoint: "/assessment/assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Draft"
							}
						},
					},
					{
						id: 'delete-assessment-status',
						heading: 'delete_assessment_status',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/assessment/assessment_status/',
						description: ['delete_assessment_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-assessment-status',
							method: "DELETE",
							endpoint: "/assessment/assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-assessment-status',
						heading: 'get_all_assessment_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/assessment_status/?name=Draft&page=1&range=5',
						description: ['all_assessment_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-assessment-status',
							method: "GET",
							endpoint: "/assessment/assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								name: "Draft",
								page: 1,
								range: 5
							}
						},
					},
				]
			},

			// -------------- Candidate -------------
			{
				id: 'candidate',
				heading: 'candidate',
				groupDescription: 'candidate_group_description',
				subSections: [
					{
						id: 'get-all-candidates',
						heading: 'get_all_candidates',
						httpRequest: 'GET https://dashboard-api.mereos.eu/candidate/?id=272&email=john.doe@example.com&page=1&range=25&$expand=school&attach=school&unattach=collected_details',
						description: ['all_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'email',
									optional: true,
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 272,
								email: "john.doe@example.com",
								page: 1,
								range: 25,
								$expand: "school"
							}
						},
					},
					{
						id: 'create-candidate',
						heading: 'create_candidate',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/',
						description: ['create_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'surname',
									optional: true,
									type: 'string',
									description: 'surname_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone',
									optional: true,
									type: 'integer',
									description: 'phone_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'group_id',
									optional: true,
									type: 'string',
									description: 'group_id_param_description'
								},
								{
									parameter: 'resume',
									optional: true,
									type: 'file',
									description: 'resume_param_description'
								},
								{
									parameter: 'photo',
									optional: true,
									type: 'file',
									description: 'photo_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									optional: true,
									type: 'integer',
									description: 'school_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate',
							method: "POST",
							endpoint: "/candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"first_name": "new",
								"surname": "lenovo",
								"email": "object@yopmail.com",
								"phone": "232325454",
								"photo": "",
								"resume": "file",
								"group_id": "123",
								"external_id": "123",
								"created_at": "2022-10-10T11:37:00.964996Z",
								"school": 6
							}
						},
					},
					{
						id: 'edit-candidate',
						heading: 'edit_candidate',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/',
						description: ['edit_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'string',
									description: 'id_param_description'
								},
								{
									parameter: 'first_name',
									optional: true,
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'surname',
									optional: true,
									type: 'string',
									description: 'surname_param_description'
								},
								{
									parameter: 'status',
									optional: true,
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'email',
									optional: true,
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone',
									optional: true,
									type: 'integer',
									description: 'phone_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'group_id',
									optional: true,
									type: 'string',
									description: 'group_id_param_description'
								},
								{
									parameter: 'resume',
									optional: true,
									type: 'file',
									description: 'resume_param_description'
								},
								{
									parameter: 'photo',
									optional: true,
									type: 'file',
									description: 'photo_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate',
							method: "PUT",
							endpoint: "/candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 205,
								"first_name": "John Doe",
								"surname": "demos",
								"status": "Active",
								"email": "john.doe@example.com",
								"phone": "232325454",
								"photo": "",
								"resume": "file",
								"group_id": "sad",
								"external_id": "sad"
							}
						},
					},
					{
						id: 'delete-candidate',
						heading: 'delete_candidate',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/candidate/',
						description: ['delete_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'delete-candidate',
							method: "DELETE",
							endpoint: "/candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-candidate',
						heading: 'search_candidate',
						httpRequest: `GET https://dashboard-api.mereos.eu/candidate/candidate_search/?search=Aute vel necessitatibus cum proident itaque conse&page=1&range=30&including_columns=&q=Q(first_name__icontains=John,surname__icontains=Doe)&$expand=school&attach=candidate_assessments&unattach=resume`,
						description: ['search_candidate_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'search-candidate',
							method: "GET",
							endpoint: "/candidate/candidate_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "Aute vel necessitatibus cum proident itaque conse",
								page: 1,
								range: 30,
								including_columns: "",
								q: "Q(first_name__icontains=John,surname__icontains=Doe)",
								$expand: "school",
								attach: "candidate_assessments",
								unattach: "resume"
							}
						},
					},
					{
						id: 'add-candidate-bulk',
						heading: 'add_candidate_bulk',
						httpRequest: `GET https://dashboard-api.mereos.eu/candidate/candidate_group/`,
						description: ['add_bulk_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'first_name',
									optional: true,
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'surname',
									optional: true,
									type: 'string',
									description: 'surname_param_description'
								},
								{
									parameter: 'email',
									optional: true,
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone',
									optional: true,
									type: 'integer',
									description: 'phone_param_description'
								},
								{
									parameter: 'external_id',
									optional: true,
									type: 'string',
									description: 'external_id_param_description'
								},
								{
									parameter: 'group_id',
									optional: true,
									type: 'string',
									description: 'group_id_param_description'
								},
								{
									parameter: 'resume',
									optional: true,
									type: 'file',
									description: 'resume_param_description'
								},
								{
									parameter: 'photo',
									optional: true,
									type: 'file',
									description: 'photo_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'add-candidate-bulk',
							method: "POST",
							endpoint: "/candidate/candidate_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: [
								{
									"first_name": "demo22",
									"surname": "demos",
									"email": "john.doe@example.com",
									"phone": "23232",
									"photo": "file",
									"resume": "file",
									"group_id": "123",
									"external_id": "123",
									"created_at": "2022-10-10T11:37:00.964996Z"
								},
								{
									"first_name": "demo23",
									"surname": "demos",
									"email": "john.doe1@example.com",
									"phone": "23232",
									"photo": "file",
									"resume": "file",
									"group_id": "123",
									"external_id": "123",
									"created_at": "2022-10-10T11:37:00.964996Z"
								}
							]
						},
					},
					{
						id: 'register-candidate',
						heading: 'register_candidate',
						httpRequest: `POST https://dashboard-api.mereos.eu/candidate/register_candidate/`,
						description: ['register_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment_id',
									type: 'integer',
									description: 'assessment_id_param_description'
								},
								{
									parameter: 'first_name',
									optional: true,
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'surname',
									optional: true,
									type: 'string',
									description: 'surname_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone',
									optional: true,
									type: 'integer',
									description: 'phone_param_description'
								},
								{
									parameter: 'notify',
									optional: true,
									type: 'boolean',
									description: 'notify_param_description'
								}
							]
						},
						requestObject: {
							id: 'register-candidate',
							method: "POST",
							endpoint: "/candidate/register_candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"assessment_id": "2693",
								"email": "john.doe@example.com",
								"first_name": "John",
								"notify": true,
								"phone": "4940404",
								"surname": "Doe"
							}
						},
					},
				]
			},

			// ______________ Candidate assessment section invite status ___________
			{
				id: 'candidate-assessment-section-invite-status',
				heading: 'candidate_assessment_section_invite_status',
				groupDescription: 'candidate_assessment_section_invite_status_group_description',
				subSections: [
					{
						id: 'create-candidate-assessment-section-invite-status',
						heading: 'create_candidate_assessment_section_invite_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_status/',
						description: ['create_candidate_assessment_section_invite_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-assessment-section-invite-status',
							method: "POST",
							endpoint: "/assessment/candidate_assessment_section_invite_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Completed"
							}
						},
					},
					{
						id: 'edit-candidate-assessment-section-invite-status',
						heading: 'edit_candidate_assessment_section_invite_status',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_status/',
						description: ['edit_candidate_assessment_section_invite_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-candidate-assessment-section-invite-status',
							method: "PUT",
							endpoint: "/assessment/candidate_assessment_section_invite_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 1,
								"name": "New"
							}
						},
					},
					{
						id: 'delete-candidate-assessment-section-invite-status',
						heading: 'delete_candidate_assessment_section_invite_status',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_status/',
						description: ['delete_candidate_assessment_section_invite_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidate-assessment-section-invite-status',
							method: "DELETE",
							endpoint: "/assessment/candidate_assessment_section_invite_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-candidate-assessment-section-invite-status',
						heading: 'get_all_candidate_assessment_section_invite_status',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_status/?page=1&range=1',
						description: ['all_candidate_assessment_section_invite_status_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidate-assessment-section-invite-status',
							method: "GET",
							endpoint: "/assessment/candidate_assessment_section_invite_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								page: 1,
								range: 1
							}
						},
					},
				]
			},

			// ______________ Candidate Assessment Status ____________
			{
				id: 'candidate-assessment-status',
				heading: 'candidate_assessment_status',
				groupDescription: 'candidate_assessment_status_group_description',
				subSections: [
					{
						id: 'create-candidate-assessment-status',
						heading: 'create_candidate_assessment_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_status/',
						description: ['create_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-candidate-assessment-status',
							method: "POST",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Completed"
							}
						},
					},
					{
						id: 'edit-candidate-assessment-status',
						heading: 'edit_candidate_assessment_status',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/candidate_assessment_status/',
						description: ['edit_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-entity',
							method: "PUT",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 7,
								"name": "New",
								"created_at": "2023-10-25T12:10:25.149490Z"
							}
						},
					},
					{
						id: 'delete-candidate-assessment-status',
						heading: 'delete_candidate_assessment_status',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/candidate/candidate_assessment_status/',
						description: ['delete_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidate-assessment-status',
							method: "DELETE",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-candidate-assessment-status',
						heading: 'get_all_candidate_assessment_status',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_status/?page=1&range=5',
						description: ['all_candidate_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/candidate/candidate_assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								page: 1,
								range: 5
							}
						},
					},
				]
			},

			// __________________ Candidate Feedback ______________
			{
				id: 'candidate-feedback',
				heading: 'candidate_feedback',
				groupDescription: 'candidate_feedback_group_description',
				subSections: [
					{
						id: 'create-feedback',
						heading: 'create_feedback',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_feedback/',
						description: ['create_candidate_feedback_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'rating',
									optional: true,
									type: 'string',
									description: 'rating_param_description'
								},
								{
									parameter: 'comment',
									optional: true,
									type: 'string',
									description: 'comment_param_description'
								},
								{
									parameter: 'candidate_assessment',
									optional: true,
									type: 'integer',
									description: 'candidate_assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-feedback',
							method: "POST",
							endpoint: "/candidate/candidate_assessment_feedback/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"rating": "Highly Unsatisfied",
								"comment": "Test",
								"candidate_assessment": 54
							}
						},
					},
					{
						id: 'edit-feedback',
						heading: 'edit_feedback',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/candidate_assessment_feedback/',
						description: ['edit_candidate_feedback_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'rating',
									optional: true,
									type: 'string',
									description: 'rating_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'comment',
									optional: true,
									type: 'string',
									description: 'comment_param_description'
								},
								{
									parameter: 'candidate_assessment',
									optional: true,
									type: 'integer',
									description: 'candidate_assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-feedback',
							method: "PUT",
							endpoint: "/candidate/candidate_assessment_feedback/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 22,
								"rating": "Highly Unsatisfied",
								"comment": "Test",
								"candidate_assessment": 54
							}
						},
					},
					{
						id: 'delete-feedback',
						heading: 'delete_feedback',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/candidate/candidate_assessment_feedback/',
						description: ['delete_candidate_feedback_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-feedback',
							method: "DELETE",
							endpoint: "/candidate/candidate_assessment_feedback/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-feedback',
						heading: 'get_all_feedback',
						httpRequest: 'GET https://dashboard-api.mereos.eu/candidate/candidate_assessment_feedback/?id=2&candidate_id=&section_id=&rating=&comment=&page=1&range=1&$expand=candidate_assessment.candidate',
						description: ['create_candidate_feedback_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'candidate_id',
									optional: true,
									type: 'integer',
									description: 'candidate_id_param_description'
								},
								{
									parameter: 'section_id',
									optional: true,
									type: 'integer',
									description: 'section_id_param_description'
								},
								{
									parameter: 'rating',
									optional: true,
									type: 'string',
									description: 'rating_param_description'
								},
								{
									parameter: 'comment',
									optional: true,
									type: 'string',
									description: 'comment_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-feedback',
							method: "GET",
							endpoint: "/candidate/candidate_assessment_feedback/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 2,
								candidate_id: "",
								section_id: "",
								rating: "",
								comment: "",
								page: 1,
								range: 1,
								$expand: "candidate_assessment.candidate"
							}
						},
					},
					{
						id: 'create-candidate-assessment-feedback-by-candidate',
						heading: 'create_candidate_assessment_feedback_by_candidate',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessment_feedback_by_candidate/',
						description: ['create_candidate_assessment_feedback_by_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'rating',
									type: 'string',
									description: 'rating_param_description'
								},
								{
									parameter: 'comment',
									type: 'string',
									description: 'comment_param_description'
								},
								{
									parameter: 'candidate_assessment',
									type: 'integer',
									description: 'candidate_assessment_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-assessment-feedback-by-candidate',
							method: "POST",
							endpoint: "/candidate/candidate_assessment_feedback_by_candidate/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"rating": "Highly Unsatisfied",
								"comment": "Test by POST",
								"candidate_assessment": 72
							}
						},
					},
				]
			},

			// ________________ Candidate invite assessment _________________
			{
				id: 'candidate-invite-assessment',
				heading: 'candidate_invite_assessment',
				groupDescription: 'candidate_invite_assessment_group_description',
				subSections: [
					{
						id: 'create-candidate-invite-assessment',
						heading: 'create_candidate_invite_assessment',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/candidate_invite_assessment/',
						description: ['create_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'candidate_assessment',
									type: 'integer',
									description: 'candidate_assessment_param_description'
								},
								{
									parameter: 'status',
									type: 'integer',
									description: 'status_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'section',
									type: 'integer',
									description: 'section_param_description'
								},
								{
									parameter: 'notify_candidate',
									type: 'boolean',
									description: 'notify_candidate_param_description'
								},
								{
									parameter: 'exam_code',
									type: 'string',
									description: 'exam_code_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-candidate-invite-assessment',
							method: "POST",
							endpoint: "/assessment/candidate_invite_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"candidate_assessment": 316,
								"status": 2,
								"start_at": "2025-06-03T08:37:16Z",
								"end_at": "2025-06-03T08:37:16Z",
								"section": 202,
								"notify_candidate": true,
								"exam_code": "{{$randomUUID}}"
							}
						},
					},
					{
						id: 'edit-candidate-invite-assessment',
						heading: 'edit_candidate_invite_assessment',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/candidate_invite_assessment/',
						description: ['edit_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'exam_code',
									type: 'integer',
									description: 'exam_code_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'candidate_assessment',
									type: 'integer',
									description: 'candidate_assessment_param_description'
								},
								{
									parameter: 'section',
									type: 'integer',
									description: 'section_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-candidate-invite-assessment',
							method: "PUT",
							endpoint: "/assessment/candidate_invite_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 1178,
								"end_at": "2023-03-10T05:30:36.316533Z",
								"exam_code": "21",
								"start_at": "2023-03-10T05:30:36.316533Z",
								"candidate_assessment": 43,
								"section": 204
							}
						},
					},
					{
						id: 'delete-candidate-invite-assessment',
						heading: 'delete_candidate_invite_assessment',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/assessment/candidate_invite_assessment/',
						description: ['delete_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidate-invite-assessment',
							method: "DELETE",
							endpoint: "/assessment/candidate_invite_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-candidate-invite-assessment',
						heading: 'get_all_candidate_invite_assessment',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/candidate_invite_assessment/?attach=section&unattach=status&order_by=id',
						description: ['all_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment',
									optional: true,
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'section',
									optional: true,
									type: 'integer',
									description: 'section_param_description'
								},
								{
									parameter: 'exam_code',
									optional: true,
									type: 'integer',
									description: 'exam_code_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates_assessments',
							method: "GET",
							endpoint: "/assessment/candidate_invite_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								attach: "section",
								unattach: "status",
								order_by: "id"
							}
						},
					},
					{
						id: 'public-candidate-invite-assessment-section',
						heading: 'public_candidate_invite_assessment_section',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/public_candidate_invite_assessment_section/?assessment=&section=&exam_code=&id=2825&$expand=section',
						description: ['public_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment',
									optional: true,
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'section',
									optional: true,
									type: 'integer',
									description: 'section_param_description'
								},
								{
									parameter: 'exam_code',
									optional: true,
									type: 'integer',
									description: 'exam_code_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
							]
						},
						requestObject: {
							id: 'public-candidate-invite-assessment-section',
							method: "GET",
							endpoint: "/assessment/public_candidate_invite_assessment_section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								assessment: "",
								section: "",
								exam_code: "",
								id: 2825,
								$expand: "section"
							}
						},
					},
					{
						id: 'change-candidate-invite-assessment-section-status',
						heading: 'change_candidate_invite_assessment_section_status',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/change_candidate_invite_assessment_section_status/',
						description: ['change_candidate_invite_assessment_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								}
							]
						},
						requestObject: {
							id: 'change-candidate-invite-assessment-section-status',
							method: "PUT",
							endpoint: "/assessment/change_candidate_invite_assessment_section_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 141,
								"status": "Attending"
							}
						},
					},
					{
						id: 'candidate-assessment-section-invite-search',
						heading: 'candidate_assessment_section_invite_search',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_search/?search=john doe&page=1&range=1&q=Q(candidate_assessment=1)&$expand=candidate_assessment, section&attach=section_sessions&unattach=status',
						description: ['search_candidate_invite_assessment_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'string',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-candidate-assessment',
							method: "GET",
							endpoint: "/assessment/candidate_assessment_section_invite_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "77c53fc5-5b3b-4ccd-818e-27bd61e64007",
								page: 1,
								range: 1,
								including_columns: "exam_code",
								q: "Q(candidate_assessment__candidate__id=1,candidate_assessment__assessment__id=2)",
								$expand: "candidate_assessment, section",
								attach: "section_sessions",
								unattach: "status"
							}
						},
					},
					{
						id: 'edit-candidate-assessment-section-invite-bulk',
						heading: 'edit_candidate_assessment_section_invite_bulk',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/edit_candidate_assessment_section_invite_bulk/',
						description: ['edit_bulk_candidate_invite_assessment_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'array',
									description: 'id_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'string',
									description: 'end_at_param_description'
								},
								{
									parameter: 'exam_code',
									optional: true,
									type: 'string',
									description: 'exam_code_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'candidate_assessment',
									optional: true,
									type: 'integer',
									description: 'candidate_assessment_param_description'
								},
								{
									parameter: 'section',
									optional: true,
									type: 'integer',
									description: 'section_param_description'
								},
								{
									parameter: 'notify',
									optional: true,
									type: 'boolean',
									description: 'notify_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-candidate-assessment-section-invite-bulk',
							method: "PUT",
							endpoint: "/assessment/edit_candidate_assessment_section_invite_bulk/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": [32, 47],
								"end_at": "2025-03-10T05:30:36.316533Z",
								"exam_code": "21",
								"start_at": "2023-03-10T05:30:36.316533Z",
								"candidate_assessment": 35,
								"section": 23,
								"notify": true
							}
						},
					},
					{
						id: 'search-invited-candidate-by-assessment',
						heading: 'search_invited_candidate_by_assessment',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/candidate_assessment_section_invite_search/?search=John&page=1&range=1&assessment_id=135&q=Q(candidate_assessment__candidate__first_name__icontains=John)&$expand=candidate_assessment, section&attach=section_sessions&unattach=status',
						description: ['search_invited_candidate_by_assessment_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: 'assessment_id',
									optional: true,
									type: 'integer',
									description: 'assessment_id_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-invited-candidate-by-assessment',
							method: "GET",
							endpoint: "/assessment/invited_candidate_by_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "John",
								page: 1,
								range: 1,
								assessment_id: 135,
								q: "Q(candidate_assessment__candidate__first_name__icontains=John)",
								$expand: "candidate_assessment, section",
								attach: "section_sessions",
								unattach: "status"
							}
						},
					},
				]
			},

			// ______________ Candidate Assessments ___________
			{
				id: 'candidates-assessment',
				heading: 'candidates_assessment',
				groupDescription: 'candidates_assessment_group_description',
				subSections: [
					{
						id: 'create-candidates-assessment',
						heading: 'create_candidates_assessment',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/candidate_assessments/',
						description: ['create_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'report',
									type: 'integer',
									description: 'report_for_create_candidate_assessment_description'
								},
							]
						},
						requestObject: {
							id: 'create-instructor',
							method: "POST",
							endpoint: "/candidate/candidate_assessments/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"status": "Pending",
								"created_at": "2023-10-24T12:21:50.195061Z",
								"candidate": 177,
								"assessment": 149,
								"report": 3,
							}
						},
					},
					{
						id: 'edit-candidates_assessment',
						heading: 'edit_candidates_assessment',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/candidate_assessments/',
						description: ['edit_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integer',
									description: 'candidate_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/candidate/candidate_assessments/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 2,
								"status": "invited",
								"created_at": "2023-10-24T12:33:16.381094Z",
								"candidate": 177,
								"assessment": 149
							}
						},
					},
					{
						id: 'delete-candidates_assessment',
						heading: 'delete_candidates_assessment',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/candidate/candidate_assessments/',
						description: ['delete_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-candidates_assessment',
							method: "DELETE",
							endpoint: "/candidate/candidate_assessments/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-candidates_assessments',
						heading: 'get_all_candidates_assessments',
						httpRequest: 'GET https://dashboard-api.mereos.eu/candidate/candidate_assessments/?attach=assessment&unattach=status',
						description: ['all_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-candidates_assessments',
							method: "GET",
							endpoint: "/candidate/candidate_assessments/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {
								attach: "assessment",
								unattach: "status"
							}
						},
					},
					{
						id: 'bulk-update-candidate-assessment',
						heading: 'bulk_update_candidate_assessment',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/bulk_update_candidate_assessments/',
						description: ['bulk_edit_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'candidate_assessments',
									type: 'array',
									description: 'candidate_assessments_param_description'
								},
								{
									parameter: 'notify',
									optional: true,
									type: 'boolean',
									description: 'notify_param_description'
								}
							]
						},
						requestObject: {
							id: 'bulk-update-candidate-assessment',
							method: "PUT",
							endpoint: "/candidate/bulk_update_candidate_assessments/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"status": 2,
								"candidate_assessments": [
									10582
								],
								"notify": false
							}
						},
					},
					{
						id: 'change-candidate-assessment-status',
						heading: 'change_candidate_assessment_status',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/candidate/change_candidate_assessment_status/',
						description: ['change_status_candidates_assessment_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'notify',
									type: 'boolean',
									description: 'notify_param_description'
								}
							]
						},
						requestObject: {
							id: 'change-candidate-assessment-status',
							method: "PUT",
							endpoint: "/candidate/change_candidate_assessment_status/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 10537,
								"notify": true,
								"status": "Completed"
							}
						},
					},
					{
						id: 'search-candidate-assessment',
						heading: 'search_candidate_assessment',
						httpRequest: 'POST https://dashboard-api.mereos.eu/candidate/search_candidate_assessment/?q=Q(created_at=\'2024-07-31T12:34:56\')&$expand=candidate&attach=assessment&unattach=status',
						description: ['search_candidates_assessment_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									type: 'string',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'search',
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'q',
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'search-candidate-assessment',
							method: "PUT",
							endpoint: "/candidate/search_candidate_assessment/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"page": 1,
								"range": 25,
								q: `Q(created_at='2024-07-31T12:34:56')`,
								"search": "",
								$expand: "candidate",
								attach: "assessment",
								unattach: "status"
							}
						},
					},
				]
			},

			// ______________Email Templates ____________
			{
				id: 'email-templates',
				heading: 'email_templates',
				groupDescription: 'email_templates_group_description',
				subSections: [
					{
						id: 'create-template',
						heading: 'create_template',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/templates/',
						description: ['create_template_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'title',
									type: 'object',
									description: 'title_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-template',
							method: "POST",
							endpoint: "/invitation/templates/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"title": {
									"html": "Reminder: {{organization}} is inviting you to attend an assessment.",
									"delta": []
								},
								"name": "Update",
								"assessment": null,
								"body": {
									"html": "<p>Dear {{full-name}},</p>",
									"delta": []
								},
								"created_at": "2023-10-23T11:55:57.458473Z"
							}
						},
					},
					{
						id: 'edit-template',
						heading: 'edit_template',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/invitation/templates/',
						description: ['edit_template_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'title',
									type: 'object',
									description: 'title_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-template',
							method: "PUT",
							endpoint: "/invitation/templates/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 212,
								"title": {
									"html": "i am okay",
									"delta": []
								},
								"name": "Complete",
								"assessment": 317,
								"body": {
									"html": "<p>Dear {{full-name}},</p><p>Thank you for completing your assessment. Your answers have been submitted for evaluation.</p><p>Best of Luck &amp; Regards,</p><p>{{organization}}</p><p>************************************************************************************* This is a system generated message. Please do not reply to this email.</p>",
									"delta": []
								},
								"created_at": "2023-10-30T09:54:06.330842Z"
							}
						},
					},
					{
						id: 'delete-template',
						heading: 'delete_template',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/invitation/templates/',
						description: ['delete_template_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-template',
							method: "DELETE",
							endpoint: "/invitation/templates/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-template',
						heading: 'get_all_template',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/templates/',
						description: ['all_template_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-template',
							method: "GET",
							endpoint: "/invitation/templates/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// ____________ Entity __________________
			{
				id: 'entity',
				heading: 'entity',
				groupDescription: 'entity_group_description',
				subSections: [
					{
						id: 'create-entity',
						heading: 'create_entity',
						httpRequest: 'POST https://dashboard-api.mereos.eu/profile/entity/',
						description: ['create_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'tooltip',
									type: 'string',
									description: 'tooltip_param_description'
								},
								{
									parameter: 'entity_group',
									type: 'integer',
									description: 'entity_group_param_description'
								},
								{
									parameter: 'dependency',
									type: 'array',
									description: 'dependency_param_description'
								},
								{
									parameter: 'combination',
									type: 'array',
									description: 'combination_for_create_entity_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-entity',
							method: "POST",
							endpoint: "/profile/entity/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "My Entity",
								"tooltip": "World Changing",
								"entity_group": 3,
								"status": "active",
								"dependency": [
									23,
									24,
								],
								"combination": [
									23,
									24,
								]
							}
						},
					},
					{
						id: 'edit-entity',
						heading: 'edit_entity',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/profile/entity/',
						description: ['edit_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'string',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'tooltip',
									type: 'string',
									description: 'tooltip_param_description'
								},
								{
									parameter: 'key',
									type: 'integer',
									description: 'key_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'image',
									type: 'file',
									description: 'image_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'entity_group',
									type: 'integer',
									description: 'entity_group_param_description'
								},
								{
									parameter: 'dependency',
									type: 'array',
									description: 'dependency_param_description'
								},
								{
									parameter: 'counter_dependency',
									type: 'array',
									description: 'counter_dependency_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-entity',
							method: "PUT",
							endpoint: "/profile/entity/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 396,
								"name": "My John Entity",
								"tooltip": "World Changing",
								"key": null,
								"status": "Active",
								"image": null,
								"modify_at": "2025-04-22T11:30:44.048142Z",
								"created_at": "2025-04-22T11:30:44.048225Z",
								"entity_group": 3,
								"dependency": [],
								"counter_dependency": []
							}
						},
					},
					{
						id: 'delete-entity',
						heading: 'delete_entity',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/profile/entity/',
						description: ['delete_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-entity',
							method: "DELETE",
							endpoint: "/profile/entity/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-entitys',
						heading: 'get_all_entitys',
						httpRequest: 'GET https://dashboard-api.mereos.eu/profile/entity/',
						description: ['all_entity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/profile/entity/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'get-entites-by-entity-group',
						heading: 'get_entites_by_entity_group',
						httpRequest: 'GET https://dashboard-api.mereos.eu/profile/get_entites_by_entity_group/',
						description: ['get_entites_by_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-entites-by-entity-group',
							method: "GET",
							endpoint: "/profile/get_entites_by_entity_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// ____________ Entity Group _______________
			{
				id: 'entity-group',
				heading: 'entity_group',
				groupDescription: 'entity_group_group_description',
				subSections: [
					{
						id: 'create-entity-group',
						heading: 'create_entity_group',
						httpRequest: 'POST https://dashboard-api.mereos.eu/profile/entity_group/',
						description: ['create_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'key',
									type: 'string',
									description: 'key_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-entity-group',
							method: "POST",
							endpoint: "/profile/entity_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "demo",
								"description": "demo",
								"key": "demo"
							}
						},
					},
					{
						id: 'edit-entity-group',
						heading: 'edit_entity_group',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/profile/entity_group/',
						description: ['edit_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-entity-group',
							method: "PUT",
							endpoint: "/profile/entity_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": "3",
								"name": "The Testing Group",
								"description": "Calculator"
							}
						},
					},
					{
						id: 'delete-entity-group',
						heading: 'delete_entity_group',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/profile/entity_group/',
						description: ['delete_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-entity-group',
							method: "DELETE",
							endpoint: "/profile/entity_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-entitys-group',
						heading: 'get_all_entitys_group',
						httpRequest: 'POST https://dashboard-api.mereos.eu/profile/entity_group/',
						description: ['all_entity_group_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-entitys-group',
							method: "GET",
							endpoint: "/profile/entity_group/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// ________________ Evaluation __________________
			{
				id: 'evaluation',
				heading: 'evaluation',
				groupDescription: 'evaluation_group_description',
				subSections: [
					{
						id: 'create-evaluation',
						heading: 'create_evaluation',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/evaluation/',
						description: ['create_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-evaluation',
							method: "POST",
							endpoint: "/section_session/evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"section_session": 2868,
								"evaluation": {},
								"status": "Active"
							}
						},
					},
					{
						id: 'edit-evaluation',
						heading: 'edit_evaluation',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/evaluation/',
						description: ['edit_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'section_session',
									optional: true,
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-evaluation',
							method: "PUT",
							endpoint: "/section_session/evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 6,
								"evaluation": {
									"status": "updated"
								},
								"modify_at": "2024-03-25T06:21:49.969338Z",
								"created_at": "2024-03-25T06:21:49.969405Z",
								"section_session": 79,
								"status": "Active"
							}
						},
					},
					{
						id: 'delete-evaluation',
						heading: 'delete_evaluation',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/evaluation/',
						description: ['delete_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-evaluation',
							method: "DELETE",
							endpoint: "/section_session/evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-evaluation',
						heading: 'get_all_evaluation',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/evaluation/',
						description: ['all_evaluation_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-ai_events',
							method: "GET",
							endpoint: "/section_session/evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'create-bulk-evaluations',
						heading: 'create_bulk_evaluations',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/bulk_evaluation/',
						description: ['create_bulk_evaluations_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'evaluations',
									type: 'array',
									description: 'evaluations_param_description'
								},
								{
									parameter: 'feedback',
									type: 'string',
									description: 'feedback_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'html',
									type: 'string',
									description: 'html_param_description'
								},
								{
									parameter: 'delta',
									type: 'array',
									description: 'delta_param_description'
								},
								{
									parameter: 'reports',
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'type',
									type: 'string',
									description: 'type_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'score',
									type: 'integer',
									description: 'score_param_description'
								},
								{
									parameter: 'remarks',
									type: 'string',
									description: 'remarks_param_description'
								},
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-bulk-evaluations',
							method: "POST",
							endpoint: "/section_session/bulk_evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"evaluations": [
									{
										"feedback": "Fair",
										"description": { "html": "<p>Hello World!</p>", "delta": [] },
										"reports": [{ "type": "audio", "status": "clear" }],
										"evaluation": { "score": 85, "remarks": "Good performance" },
										"session": 1,
										"status": "Active"
									},
									{
										"feedback": "Fraud",
										"description": { "html": "<p>Hello World!</p>", "delta": [] },
										"reports": [{ "type": "video", "status": "flagged" }],
										"evaluation": { "score": 45, "remarks": "Requires attention" },
										"session": 2,
										"status": "Active"
									}
								]
							}

						},
					},
					{
						id: 'update-bulk-evaluations',
						heading: 'update_bulk_evaluations',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/bulk_evaluation/',
						description: ['update_bulk_evaluations_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'evaluations',
									type: 'array',
									description: 'evaluations_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'feedback',
									type: 'string',
									description: 'feedback_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'session',
									type: 'integer',
									description: 'session_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'description',
									type: 'object',
									description: 'description_param_description'
								},
								{
									parameter: 'html',
									type: 'string',
									description: 'html_param_description'
								},
								{
									parameter: 'delta',
									type: 'array',
									description: 'delta_param_description'
								},
								{
									parameter: 'reports',
									type: 'array',
									description: 'reports_param_description'
								},
								{
									parameter: 'type',
									type: 'string',
									description: 'type_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'score',
									type: 'integer',
									description: 'score_param_description'
								},
								{
									parameter: 'remarks',
									type: 'string',
									description: 'remarks_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-bulk-evaluations',
							method: "PUT",
							endpoint: "/section_session/bulk_evaluation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"evaluations": [
									{
										"id": 1,
										"description": { "html": "Update", "delta": [] },
										"feedback": "Fair",
										"reports": [
											{
												"type": "audio",
												"status": "clear"
											}
										],
										"evaluation": {
											"score": 85,
											"remarks": "Good performance"
										},
										"modify_at": "2024-10-31T08:46:58.037523Z",
										"created_at": "2024-10-31T08:46:58.037536Z",
										"session": 4,
										"status": "Active"
									},
									{
										"id": 2,
										"description": { "html": "Suspicious Update2.", "delta": [] },
										"feedback": "Fraud",
										"reports": [
											{
												"type": "video",
												"status": "flagged"
											}
										],
										"evaluation": {
											"score": 45,
											"remarks": "Requires attention"
										},
										"modify_at": "2024-10-31T08:46:58.041910Z",
										"created_at": "2024-10-31T08:46:58.041919Z",
										"session": 5
									}
								]
							}
						},
					},
				]
			},

			// ________________ Events _________________
			{
				id: 'event',
				heading: 'event',
				groupDescription: 'event_group_description',
				subSections: [
					{
						id: 'create-event',
						heading: 'create_event',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/event/',
						description: ['create_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-event',
							method: "POST",
							endpoint: "/section_session/event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "New Event 857",
								"value": "New Event 857",
								"section_session": 857,
								"created_at": "2024-03-04T07:20:03.978409Z",
								"start_at": "2023-05-25T06:11",
								"end_at": "2024-07-01T06:11",
							}
						},
					},
					{
						id: 'event-by-candidate',
						heading: 'event_by_candidate',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/post_event/',
						description: ['create_event_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'event-by-candidate',
							method: "POST",
							endpoint: "/section_session/post_event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "New Event candidate ",
								"value": "New Event candidate 1122",
								"section_session": 1513,
								"created_at": "2024-03-04T07:20:03.978409Z",
								"start_at": "2023-05-25T06:11",
								"end_at": "2024-07-01T06:11",
							}
						},
					},
					{
						id: 'edit-event',
						heading: 'edit_event',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/event/',
						description: ['edit_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-event',
							method: "PUT",
							endpoint: "/section_session/event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 1,
								"name": "Testing Event Updated",
								"value": "Testing Event Updated",
								"created_at": "2024-03-04T07:20:03.978409Z",
								"section_session": 127,
								"start_at": "2023-05-25T06:11",
								"end_at": "2024-07-01T06:11",
							}
						},
					},
					{
						id: 'delete-event',
						heading: 'delete_event',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/event/',
						description: ['delete_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-event',
							method: "DELETE",
							endpoint: "/section_session/event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-event',
						heading: 'get_all_event',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/event/',
						description: ['all_event_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-event',
							method: "GET",
							endpoint: "/section_session/event/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'create-bulk-events',
						heading: 'create_bulk_events',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/bulk_events/',
						description: ['create_bulk_events_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'events',
									type: 'array',
									description: 'events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-bulk-events',
							method: "POST",
							endpoint: "/section_session/bulk_events/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"events": [
									{
										"name": "event1",
										"value": "123",
										"section_session": 135,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"section_session": 135,
										"start_at": "",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					},
					{
						id: 'create-candidate-bulk-events',
						heading: 'create_candidate_bulk_events',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/candidate_bulk_events/',
						description: ['create_candidate_bulk_events_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'events',
									type: 'array',
									description: 'events_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'value',
									type: 'string',
									description: 'value_param_description'
								},
								{
									parameter: 'section_session',
									type: 'integer',
									description: 'section_session_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-bulk-events',
							method: "POST",
							endpoint: "/section_session/candidate_bulk_events/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"events": [
									{
										"name": "event1",
										"value": "123",
										"section_session": 135,
										"start_at": "2025-08-28T12:00:00Z",
										"end_at": "2025-08-28T13:00:00Z"
									},
									{
										"name": "event2",
										"value": "456",
										"section_session": 135,
										"start_at": "",
										"end_at": "2025-08-28T15:00:00Z"
									},
								]
							}
						},
					},
				]
			},

			// ____________ Features ___________________
			{
				id: 'features',
				heading: 'features',
				groupDescription: 'features_group_description',
				subSections: [
					{
						id: 'create-features',
						heading: 'create_features',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/feature/',
						description: ['create_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-features',
							method: "POST",
							endpoint: "/role/feature/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "view_candidate",
								"description": "These feature enable user to perform candidate related features."
							}
						},
					},
					{
						id: 'edit-features',
						heading: 'edit_features',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/feature/',
						description: ['edit_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-features',
							method: "PUT",
							endpoint: "/role/feature/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "view_candidate",
								"description": "These feature enable user to perform candidate related features."
							}
						},
					},
					{
						id: 'delete-features',
						heading: 'delete_features',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/feature/',
						description: ['delete_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-features',
							method: "DELETE",
							endpoint: "/role/feature/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-features',
						heading: 'get_all_features',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/feature/?id=3&name=Proctoring&description=Feature description',
						description: ['all_feature_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									optional: true,
									type: 'string',
									description: 'description_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-features',
							method: "GET",
							endpoint: "/role/feature/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 3,
								name: "Proctoring",
								description: "Feature description"
							}
						},
					},
				]
			},

			//  ________________________ General __________________
			// {
			// 	id: 'general',
			// 	heading: 'general',
			// 	groupDescription: 'general_group_description',
			// 	subSections: [
			// 		{
			// 			id: 'test-upload-speed',
			// 			heading: 'Test upload speed',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/test-upload-speed',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'test',
			// 						type: 'string',
			// 						description: 'test'
			// 					}
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'test-upload-speed',
			// 				method: "POST",
			// 				endpoint: "/general/test-upload-speed",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"test": "text",
			// 				}
			// 			},
			// 		},
			// 		{
			// 			id: 'upload-image',
			// 			heading: 'Upload Image',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/images',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'image',
			// 						type: 'file',
			// 						description: 'image_param_description'
			// 					}
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'upload-image',
			// 				method: "POST",
			// 				endpoint: "/general/images",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"image": "binary",
			// 				}
			// 			},
			// 		},
			// 		{
			// 			id: 'upload-resume',
			// 			heading: 'Upload resume',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/images',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'file',
			// 						type: 'file',
			// 						description: 'resume file'
			// 					},
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'upload-resume',
			// 				method: "POST",
			// 				endpoint: "/general/images",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"file": "binary",
			// 				}
			// 			},
			// 		},
			// 		{
			// 			id: 'upload-video',
			// 			heading: 'Upload Video',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/video',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'videos',
			// 						type: 'file',
			// 						description: 'video file in form data'
			// 					},
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'upload-video',
			// 				method: "POST",
			// 				endpoint: "/general/video",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"videos": "binary",
			// 				}
			// 			},
			// 		},
			// 		{
			// 			id: 'upload-file',
			// 			heading: 'Upload File',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/upload_file/',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'folder_name',
			// 						type: 'string',
			// 						description: 'folder_name of s3 bucket'
			// 					},
			// 					{
			// 						parameter: 'files',
			// 						type: 'file',
			// 						description: 'files in form Data'
			// 					},
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'upload-file',
			// 				method: "POST",
			// 				endpoint: "/general/upload_file/",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"folder_name": "Example folder",
			// 					"files": "binary",
			// 				}
			// 			},
			// 		},
			// 		{
			// 			id: 'recognition',
			// 			heading: 'recognition',
			// 			httpRequest: 'POST https://dashboard-api.mereos.eu/general/rekognition/',
			// 			description: ['The Create Instructor API allows users to programmatically add new instructors to the platform. This API enables the submission of essential instructor details, such as name, email, and other relevant credentials, to create a new instructor profile..'],
			// 			table: {
			// 				columns: [
			// 					{
			// 						heading: `${'parameter'}`,
			// 						accessor: 'parameter'
			// 					},
			// 					{
			// 						heading: `${'type'}`,
			// 						accessor: 'type'
			// 					},
			// 					{
			// 						heading: `${'description'}`,
			// 						accessor: 'description'
			// 					},
			// 				],
			// 				data: [
			// 					{
			// 						parameter: 'image',
			// 						type: 'file',
			// 						description: 'image_param_description'
			// 					},
			// 				]
			// 			},
			// 			requestObject: {
			// 				id: 'recognition',
			// 				method: "POST",
			// 				endpoint: "/general/rekognition/",
			// 				host: "https://dashboard-api.mereos.eu",
			// 				contentType: "application/json",
			// 				body: {
			// 					"image": "binary",
			// 				}
			// 			},
			// 		},
			// 	]
			// },

			// ----------- Instructor -------------
			{
				id: 'instructor',
				heading: 'instructor',
				groupDescription: 'instructor_group_description',
				subSections: [
					{
						id: 'create-instructor',
						heading: 'create_instructor',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/instructors/',
						description: ['create_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'first_name',
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'last_name',
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'username',
									type: 'string',
									description: 'username_param_description'
								},
								{
									parameter: 'email',
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'integer',
									description: 'phone_number_param_description'
								},
								{
									parameter: 'is_staff',
									type: 'boolean',
									description: 'is_staff_param_description'
								},
								{
									parameter: 'is_superuser',
									type: 'boolean',
									description: 'is_superuser_param_description'
								},
								{
									parameter: 'role',
									type: 'integer',
									description: 'role_param_description'
								},
								{
									parameter: 'password',
									type: 'password',
									description: 'password_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-instructor',
							method: "POST",
							endpoint: "/role/instructors/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"email": "john.doe@example.com",
								"password": "*******",
								"username": "john_doe",
								"first_name": "John",
								"last_name": "Doe",
								"phone_number": "123456789",
								"is_staff": false,
								"is_superuser": false,
								"role": 8
							}
						},
					},
					{
						id: 'edit-instructor',
						heading: 'edit_instructor',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/instructors/',
						description: ['edit_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'string',
									description: 'id_param_description'
								},
								{
									parameter: 'first_name',
									optional: true,
									type: 'string',
									description: 'first_name_param_description'
								},
								{
									parameter: 'last_name',
									optional: true,
									type: 'string',
									description: 'last_name_param_description'
								},
								{
									parameter: 'username',
									optional: true,
									type: 'string',
									description: 'username_param_description'
								},
								{
									parameter: 'email',
									optional: true,
									type: 'string',
									description: 'email_param_description'
								},
								{
									parameter: 'phone_number',
									optional: true,
									type: 'integer',
									description: 'phone_number_param_description'
								},
								{
									parameter: 'is_staff',
									type: 'boolean',
									description: 'is_staff_param_description'
								},
								{
									parameter: 'is_superuser',
									type: 'boolean',
									description: 'is_superuser_param_description'
								},
								{
									parameter: 'role',
									type: 'integer',
									description: 'role_param_description'
								},
								{
									parameter: 'password',
									type: 'password',
									description: 'password_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/role/instructors/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": "3",
								"email": "john.doe@example.com",
								"password": "*******",
								"username": "john_doe",
								"first_name": "John",
								"last_name": "Doe",
								"phone_number": "123456789",
								"is_staff": false,
								"is_superuser": false,
								"role": 8
							}
						},
					},
					{
						id: 'delete-instructor',
						heading: 'delete_instructor',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/instructors/',
						description: ['delete_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-instructor',
							method: "DELETE",
							endpoint: "/role/instructors/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-instructors',
						heading: 'get_all_instructors',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/instructors/',
						description: ['all_instructor_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/role/instructors/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// ----------- Instructor Activity -------------
			{
				id: 'instructor-activity',
				heading: 'instructor_activity',
				groupDescription: 'instructor_activity_group_description',
				subSections: [
					{
						id: 'get-instructor-activity',
						heading: 'get_instructor_activity',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/instructor-activities/?page=1&range=1&$expand=instructor.school',
						description: ['get_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}]
						},
						requestObject: {
							id: 'get-instructor-activity',
							method: "GET",
							endpoint: "/role/instructor-activities/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								page: 1,
								range: 1,
								$expand: "instructor.school"
							}
						},
					},
					{
						id: 'create-instructor-activity',
						heading: 'create_instructor_activity',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/instructor-activities/',
						description: ['create_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]

						},
						requestObject: {
							id: 'create-instructor-activity',
							method: "POST",
							endpoint: "/role/instructor-activities/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"body": {
									"html": "<p>Hello World!</p>",
									"delta": []
								},
								"instructor": 12,
								"tags": {},
								"modify_at": "2024-10-01T13:01:27.604282Z",
								"created_at": "2024-10-01T13:01:27.604297Z"
							}
						},
					},
					{
						id: 'edit-instructor-activity',
						heading: 'edit_instructor_activity',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/instructor-activities/',
						description: ['edit_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'body',
									type: 'object',
									description: 'body_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'tags',
									type: 'object',
									description: 'tags_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]

						},
						requestObject: {
							id: 'edit-instructor-activity',
							method: "PUT",
							endpoint: "/role/instructor-activities/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 86,
								"body": {
									"html": "<p>test new.....</p>",
									"delta": []
								},
								"instructor": 32,
								"tags": {},
								"modify_at": "2024-11-26T07:14:35.651909Z",
								"created_at": "2024-11-26T07:14:35.651999Z"
							}
						},
					},
					{
						id: 'delete-instructor-activity',
						heading: 'delete_instructor_activity',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/instructor-activities/?id=84',
						description: ['delete_instructor_activity_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]

						},
						requestObject: {
							id: 'delete-instructor-activity',
							method: "DELETE",
							endpoint: "/role/instructor-activities/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 84
							}
						},
					},
					{
						id: 'search-instructor-activity',
						heading: 'search_instructor_activity',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/instructor_activities_search/?search=&page=1&range=1&q=Q(instructor__first_name__icontains=John)&$expand=instructor.role, instructor.school&attach=instructor&unattach=body',
						description: ['search_instructor_activity_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-instructor-activity',
							method: "GET",
							endpoint: "/role/instructor_activities_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "",
								page: 1,
								range: 1,
								q: "Q(instructor__first_name__icontains=John)",
								$expand: "instructor.role, instructor.school",
								attach: "instructor",
								unattach: "body"
							}
						},
					},
				]
			},

			// _____________ Invitation _______________
			{
				id: 'invitations',
				heading: 'invitations',
				groupDescription: 'invitations_group_description',
				subSections: [
					{
						id: 'create-invite',
						heading: 'create_invite',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/create_invite',
						description: ['create_invite_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									optional: true,
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'notify_candidate',
									optional: true,
									type: 'boolean',
									description: 'notify_candidate_param_description'
								},
								{
									parameter: 'section_id',
									type: 'integer',
									description: 'section_id_param_description'
								},
								{
									parameter: 'assessment_id',
									type: 'integer',
									description: 'assessment_id_param_description'
								},
								{
									parameter: 'candidate_id',
									optional: true,
									type: 'array',
									description: 'candidate_id_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-invite',
							method: "POST",
							endpoint: "/invitation/create_invite",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "John Doe",
								"start_at": "2025-12-31T07:37:00Z",
								"end_at": "2026-01-03T08:24:00Z",
								"notify_candidate": true,
								"section_id": 2176,
								"assessment_id": 1485,
								"candidate_id": [
									10823
								]
							}
						},
					},
					{
						id: 'search-invite',
						heading: 'search_invite',
						httpRequest: `POST https://dashboard-api.mereos.eu/invitation/invitation_search/?q=Q(name__icontains=John)&$expand=assessment,section&attach=candidate&unattach=notify_candidate`,
						description: ['search_invite_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'text',
									type: 'string',
									description: 'text_for_search_invite_description'
								},
								{
									parameter: 'pagenumber',
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'including_columns',
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-invite',
							method: "POST",
							endpoint: "/invitation/invitation_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"text": "",
								"including_columns": [
									"name"
								],
								"pagenumber": 1,
								"range": 5,
								q: "Q(name__icontains=John)",
								$expand: "assessment,section",
								attach: "candidate",
								unattach: "notify_candidate"
							}

						},
					},
					{
						id: 'delete-invite',
						heading: 'delete_invite',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/invitation/invitation_delete/',
						description: ['delete_invite_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-invite',
							method: "DELETE",
							endpoint: "/invitation/invitation_delete/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-invites',
						heading: 'get_all_invites',
						httpRequest: 'GET https://dashboard-api.mereos.eu/invitation/',
						description: ['all_invite_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-candidates',
							method: "GET",
							endpoint: "/invitation/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'send-reminder',
						heading: 'send_reminder',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/send_reminder/',
						description: ['send_reminder_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'candidate_assessments',
									type: 'array',
									description: 'candidate_assessments_param_description'
								},
								{
									parameter: 'notify',
									type: 'boolean',
									description: 'notify_param_description'
								},
							]
						},
						requestObject: {
							id: 'send-reminder',
							method: "POST",
							endpoint: "/invitation/send_reminder/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"candidate_assessments": [332],
								"notify": true
							}
						},
					},
					{
						id: 'bulk-invitation-last-date-update',
						heading: 'bulk_invitation_last_date_update',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/invitation/bulk_invitation_last_date_update/',
						description: ['bulk_invitation_last_date_update_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'ids',
									type: 'array',
									description: 'ids_for_update_bulk_invitations_last_date_description'
								},
								{
									parameter: 'new_last_date',
									type: 'date',
									description: 'new_last_date_for_update_bulk_invitations_last_date_description'
								},
							]
						},
						requestObject: {
							id: 'bulk-invitation-last-date-update',
							method: "PUT",
							endpoint: "/invitation/bulk_invitation_last_date_update/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"ids": [
									271,
									272,
									274
								],
								"new_last_date": "2024-1-1T07:06:44Z"
							}
						},
					},
					{
						id: 're-invite',
						heading: 're_invite',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/re-invite/',
						description: ['re_invite_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'scheduled_at',
									type: 'date',
									description: 'scheduled_at_param_description'
								},
								{
									parameter: 'notify_candidate',
									type: 'boolean',
									description: 'notify_candidate_param_description'
								},
								{
									parameter: 'section_id',
									type: 'integer',
									description: 'section_id_param_description'
								},
								{
									parameter: 'assessment_id',
									type: 'integer',
									description: 'assessment_id_param_description'
								},
								{
									parameter: 'candidate_id',
									type: 'array',
									description: 'candidate_id_param_description'
								},
							]
						},
						requestObject: {
							id: 're-invite',
							method: "POST",
							endpoint: "/invitation/re-invite/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "John Doe",
								"start_at": "2023-05-25T06:11",
								"end_at": "2024-07-01T06:11",
								"scheduled_at": "2023-05-27T06:11",
								"notify_candidate": true,
								"section_id": 205,
								"assessment_id": 328,
								"candidate_id": [
									272
								]
							}
						},
					},
				]
			},

			// ____________ Notification _____________
			{
				id: 'notification',
				heading: 'notification',
				groupDescription: 'notification_group_description',
				subSections: [
					{
						id: 'create-notification',
						heading: 'create_notification',
						httpRequest: 'POST https://dashboard-api.mereos.eu/invitation/notification/',
						description: ['create_notification_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'to_address',
									type: 'string',
									description: 'to_address_param_description'
								},
								{
									parameter: 'cc_address',
									type: 'string',
									description: 'cc_address_param_description'
								},
								{
									parameter: 'bcc_addresses',
									type: 'string',
									description: 'bcc_addresses_param_description'
								},
								{
									parameter: 'content',
									type: 'object',
									description: 'content_param_description'
								},
								{
									parameter: 'subject',
									type: 'object',
									description: 'subject_param_description'
								},
								{
									parameter: 'status',
									type: 'integer',
									description: 'status_param_description'
								},
								{
									parameter: 'enqueued',
									type: 'boolean',
									description: 'enqueued_param_description'
								},
								{
									parameter: 'scheduled_at',
									type: 'date',
									description: 'scheduled_at_param_description'
								},
								{
									parameter: 'sent_at',
									type: 'date',
									description: 'sent_at_param_description'
								},
								{
									parameter: 'read_at',
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'from_address',
									type: 'string',
									description: 'from_address_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-instructor',
							method: "POST",
							endpoint: "/invitation/notification/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"to_address": "New",
								"cc_address": "New",
								"bcc_addresses": [],
								"content": {
									"html": "My New Notification",
									"delta": []
								},
								"subject": {
									"html": "My New Notification",
									"delta": []
								},
								"status": "sent",
								"enqueued": true,
								"scheduled_at": "2023-10-22T10:24:38Z",
								"sent_at": "2023-10-22T10:24:49Z",
								"read_at": "2023-10-22T10:24:51Z",
								"from_address": "Address",
								"created_at": "2023-10-22T10:24:56.112680Z"
							}
						},
					},
					{
						id: 'edit-notification',
						heading: 'edit_notification',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/invitation/notification/',
						description: ['edit_notification_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'to_address',
									type: 'string',
									description: 'to_address_param_description'
								},
								{
									parameter: 'cc_address',
									type: 'string',
									description: 'cc_address_param_description'
								},
								{
									parameter: 'bcc_addresses',
									type: 'string',
									description: 'bcc_addresses_param_description'
								},
								{
									parameter: 'content',
									type: 'object',
									description: 'content_param_description'
								},
								{
									parameter: 'subject',
									type: 'object',
									description: 'subject_param_description'
								},
								{
									parameter: 'status',
									type: 'integer',
									description: 'status_param_description'
								},
								{
									parameter: 'enqueued',
									type: 'boolean',
									description: 'enqueued_param_description'
								},
								{
									parameter: 'scheduled_at',
									type: 'date',
									description: 'scheduled_at_param_description'
								},
								{
									parameter: 'sent_at',
									type: 'date',
									description: 'sent_at_param_description'
								},
								{
									parameter: 'read_at',
									type: 'date',
									description: 'read_at_param_description'
								},
								{
									parameter: 'from_address',
									type: 'string',
									description: 'from_address_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-instructor',
							method: "PUT",
							endpoint: "/invitation/notification/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								"id": 1024,
								"to_address": "NewOne",
								"cc_address": "NewOne",
								"bcc_addresses": [],
								"content": {
									"html": "My New Notification",
									"delta": []
								},
								"subject": {
									"html": "My New Notification",
									"delta": []
								},
								"status": "pending",
								"enqueued": false,
								"scheduled_at": "2023-10-22T10:24:38Z",
								"sent_at": "2023-10-22T10:24:49Z",
								"read_at": "2023-10-22T10:24:51Z",
								"from_address": "Address",
								"created_at": "2023-10-22T10:30:39.681973Z"
							}
						},
					},
					{
						id: 'delete-notification',
						heading: 'delete_notification',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/invitation/notification/',
						description: ['delete_notification_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-instructor',
							method: "DELETE",
							endpoint: "/invitation/notification/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-notification',
						heading: 'get_all_notification',
						httpRequest: 'GET https://dashboard-api.mereos.eu/invitation/notification/',
						description: ['all_notification_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-notification',
							method: "GET",
							endpoint: "/invitation/notification/",
							host: "https://dashboard-api.mereos.eu/",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// ____________Panels ______________
			{
				id: 'panel',
				heading: 'panel',
				groupDescription: 'panel_group_description',
				subSections: [
					{
						id: 'create-panel',
						heading: 'create_panel',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/panel/',
						description: ['create_panel_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-panel',
							method: "POST",
							endpoint: "/section_session/panel/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"instructor": 8,
								"name": "John Doe",
								"start_at": "2024-03-14T05:30:05.930649Z",
								"end_at": "2024-03-14T05:30:05.930649Z",
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z"
							}
						},
					},
					{
						id: 'edit-panel',
						heading: 'edit_panel',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/panel/',
						description: ['edit_panel_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-panel',
							method: "PUT",
							endpoint: "/section_session/panel/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 183,
								"name": "John Doe",
								"instructor": 12,
								"created_by": 12,
								"start_at": "2023-05-25T06:11",
								"end_at": "2024-07-01T06:11",
							}
						},
					},
					{
						id: 'delete-panel',
						heading: 'delete_panel',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/panel/',
						description: ['delete_panel_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-panel',
							method: "DELETE",
							endpoint: "/section_session/panel/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-panel',
						heading: 'search_panel',
						httpRequest: `GET https://dashboard-api.mereos.eu/section_session/panel_search/?search=&page=1&range=25&including_columns=name&q=Q(name__icontains=Morning Panel)&$expand=instructor&attach=instructor&unattach=section_sessions`,
						description: ['search_panel_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-panel',
							method: "GET",
							endpoint: "/section_session/panel_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "",
								page: 1,
								range: 25,
								including_columns: "name",
								q: "Q(name__icontains=Morning Panel)",
								$expand: "instructor",
								attach: "instructor",
								unattach: "section_sessions"
							}
						},
					},
					{
						id: 'duplicate-panel',
						heading: 'duplicate_panel',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/duplicate_panel/',
						description: ['duplicate_panel_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'panel_name',
									type: 'string',
									description: 'panel_name_for_duplicate_panel_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'duplicate-panel',
							method: "POST",
							endpoint: "/section_session/duplicate_panel/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 67,
								"panel_name": "New panel testing 3"
							}
						}
					},
					{
						id: 'panel-with-sessions',
						heading: 'panel_with_sessions',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/panel_with_sessions/',
						description: ['create_panel_wuth_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'panel-with-sessions',
							method: "POST",
							endpoint: "/section_session/panel_with_sessions/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"instructor": 8,
								"name": "Proctoring Playlist 1144",
								"start_at": null,
								"end_at": null,
								"sessions": [132],
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z"
							}
						},
					},
					{
						id: 'edit-panel-with-sessions',
						heading: 'edit_panel_with_sessions',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/panel_with_sessions/',
						description: ['edit_panel_with_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-panel-with-sessions',
							method: "POST",
							endpoint: "/section_session/panel_with_sessions/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 7,
								"instructor": 8,
								"name": "Proctoring Playlist 1 Updated ....!",
								"start_at": null,
								"end_at": null,
								"sessions": [1484],
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z"
							}
						},
					},
					{
						id: 'get-all-panels',
						heading: 'get_all_panels',
						httpRequest: 'GET https://dashboard-api.mereos.eu/section_session/panel/?attach=instructor&unattach=section_sessions',
						description: ['all_panel_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-panels',
							method: "GET",
							endpoint: "/section_session/panel/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {
								attach: "instructor",
								unattach: "section_sessions"
							}
						},
					},
				]
			},

			// ____________Playlist ___________________
			{
				id: 'playlist',
				heading: 'playlist',
				groupDescription: 'playlist_group_description',
				subSections: [
					{
						id: 'create-playlist',
						heading: 'create_playlist',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/playlist/',
						description: ['create_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'created_by',
									type: 'integer',
									description: 'created_by_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-playlist',
							method: "POST",
							endpoint: "/section_session/playlist/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"instructor": 8,
								"name": "John Doe",
								"start_at": null,
								"end_at": null,
								"settings": {},
								"created_by": 12
							}
						},
					},
					{
						id: 'edit-playlist',
						heading: 'edit_playlist',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/playlist/',
						description: ['edit_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'instructor',
									optional: true,
									type: 'integer',
									description: 'instructor_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-playlist',
							method: "PUT",
							endpoint: "/section_session/playlist/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 2,
								"name": "John Doe Updated",
								"start_at": null,
								"end_at": null,
								"settings": {},
								"modify_at": "2024-03-14T06:00:43.152656Z",
								"created_at": "2024-03-14T06:00:43.152691Z",
								"instructor": 8
							}
						},
					},
					{
						id: 'delete-playlist',
						heading: 'delete_playlist',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/playlist/',
						description: ['delete_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-playlist',
							method: "DELETE",
							endpoint: "/section_session/playlist/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-playlist',
						heading: 'search_playlist',
						httpRequest: `GET https://dashboard-api.mereos.eu/section_session/playlist_search/?search=john.doe@example.com&page=1&range=1&including_columns=instructor__email&q=Q(name="New playlist with lates sessions")&$expand=created_by.school&attach=instructor&unattach=section_sessions`,
						description: ['search_playlist_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-playlist',
							method: "GET",
							endpoint: "/section_session/playlist_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "john.doe@example.com",
								page: 1,
								range: 1,
								including_columns: "instructor__email",
								q: 'Q(name="New playlist with lates sessions")',
								$expand: "created_by.school",
								attach: "instructor",
								unattach: "section_sessions"
							}
						},
					},
					{
						id: 'duplicate-playlist',
						heading: 'duplicate_playlist',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/duplicate_playlist/',
						description: ['duplicate_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'playlist_name',
									type: 'string',
									description: 'playlist_name_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								}
							]
						},
						requestObject: {
							id: 'duplicate-playlist',
							method: "POST",
							endpoint: "/section_session/duplicate_playlist/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 67,
								"playlist_name": "New Playlist testing 3"
							}
						}
					},
					{
						id: 'playlist-with-sessions',
						heading: 'playlist_with_sessions',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/playlist_with_sessions/',
						description: ['create_playlist_wuth_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									optional: true,
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									optional: true,
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									optional: true,
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'modify_at',
									optional: true,
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									optional: true,
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-playlist',
							method: "POST",
							endpoint: "/section_session/playlist_with_sessions/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"instructor": 25,
								"name": "Proctoring Playlist 1",
								"start_at": null,
								"end_at": "2024-04-14T05:30:05.930649Z",
								"settings": {},
								"sessions": [1484],
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z"
							}
						},
					},
					{
						id: 'edit-playlist-with-sessions',
						heading: 'edit_playlist_with_sessions',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/playlist_with_sessions/',
						description: ['edit_playlist_with_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'start_at',
									type: 'date',
									description: 'start_at_param_description'
								},
								{
									parameter: 'end_at',
									type: 'date',
									description: 'end_at_param_description'
								},
								{
									parameter: 'settings',
									type: 'object',
									description: 'settings_param_description'
								},
								{
									parameter: 'sessions',
									type: 'array',
									description: 'sessions_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-playlist',
							method: "PUT",
							endpoint: "/section_session/playlist_with_sessions/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 26,
								"instructor": 41,
								"name": "Proctoring Playlist 1 Updated ....!",
								"start_at": null,
								"end_at": null,
								"settings": { "ai_logs": "", "screen_logs": "", "maximum_video": "1", "screen_allowed": "", "webcam_allowed": "" },
								"sessions": [1470, 1471],
								"modify_at": "2024-03-14T05:30:05.930649Z",
								"created_at": "2024-03-14T05:30:05.930661Z"
							}
						},
					},
					{
						id: 'get-all-playlists',
						heading: 'get_all_playlists',
						httpRequest: 'GET https://dashboard-api.mereos.eu/section_session/playlist/?id=5&page=1&range=100&$expand=instructor&attach=instructor&unattach=section_sessions',
						description: ['all_playlist_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-all-playlists',
							method: "GET",
							endpoint: "/section_session/playlist/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 5,
								page: 1,
								range: 100,
								$expand: "instructor",
								attach: "instructor",
								unattach: "section_sessions"
							}
						},
					},
				]
			},

			// _______________ Feature Set/ Role ______________
			{
				id: 'role',
				heading: 'role',
				groupDescription: 'role_group_description',
				subSections: [
					{
						id: 'create-role',
						heading: 'create_role',
						httpRequest: 'POST https://dashboard-api.mereos.eu/role/role/',
						description: ['create_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'features',
									type: 'array',
									description: 'features_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'create-role',
							method: "POST",
							endpoint: "/role/role/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"features": [
									{
										"id": 1,
										"name": "view_candidate",
										"description": "These feature enable user to perform candidate related features."
									},
									{
										"id": 2,
										"name": "view_assessment",
										"description": "These feature enable user to perform assessment related features."
									},
									{
										"id": 3,
										"name": "view_invitation",
										"description": "These feature enable user to perform invitation related features."
									}
								],
								"name": "Master Recruiter",
								"description": "Some quick example text to build on the card title and make up the bulk of the card's content.",
								"created_at": "2022-12-06T08:04:02.311950Z"
							}
						},
					},
					{
						id: 'edit-role',
						heading: 'edit_role',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/role/role/',
						description: ['edit_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'features',
									type: 'array',
									description: 'features_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
							]
						},
						requestObject: {
							id: 'edit-role',
							method: "PUT",
							endpoint: "/role/role/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 25,
								"features": [
									{
										"id": 1,
										"name": "view_candidate",
										"description": "These feature enable user to perform candidate related features."
									},
									{
										"id": 2,
										"name": "view_assessment",
										"description": "These feature enable user to perform assessment related features."
									},
									{
										"id": 3,
										"name": "view_invitation",
										"description": "These feature enable user to perform invitation related features."
									}
								],
								"name": "Master Recruiter",
								"description": "Some quick example text to build on the card title and make up the bulk of the card's content.",
								"created_at": "2022-12-06T08:04:02.311950Z"
							}
						},
					},
					{
						id: 'delete-role',
						heading: 'delete_role',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/role/role/',
						description: ['delete_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-role',
							method: "DELETE",
							endpoint: "/role/role/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-role',
						heading: 'get_all_role',
						httpRequest: 'GET https://dashboard-api.mereos.eu/role/role/',
						description: ['all_role_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-role',
							method: "GET",
							endpoint: "/role/role/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
				]
			},

			// _______________ Report Delivery ______________
			{
				id: 'report-delivery',
				heading: 'report_delivery',
				groupDescription: 'report_delivery_group_description',
				subSections: [
					{
						id: 'get-all-report-delivery',
						heading: 'get_all_report_delivery',
						httpRequest: 'GET https://dashboard-api.mereos.eu/report/report_delivery/',
						description: ['get_all_report_delivery_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: []
						},
						requestObject: {
							id: 'get-all-report-delivery',
							method: "GET",
							endpoint: "/report/report_delivery/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",

							body: {}
						},
					},
					{
						id: 'create-report-delivery',
						heading: 'create_report_delivery',
						httpRequest: 'POST https://dashboard-api.mereos.eu/report/report_delivery/',
						description: ['create_report_delivery_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'title',
									type: 'object',
									description: 'title_param_description'
								},
								{
									parameter: 'template',
									type: 'object',
									description: 'template_param_description'
								},
								{
									parameter: 'email_address',
									type: 'string',
									description: 'email_address_param_description'
								},
								{
									parameter: 'frequency',
									type: 'string',
									description: 'frequency_param_description'
								},
								{
									parameter: 'last_report_sent',
									type: 'date',
									description: 'last_report_sent_param_description'
								},
								{
									parameter: 'school',
									type: 'object',
									description: 'school_param_description'
								}
							]

						},
						requestObject: {
							id: 'create-report-delivery',
							method: "POST",
							endpoint: "/report/report_delivery/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"title": {
									"html": "<p>html testing</p>",
									"delta": []
								},
								"template": {
									"html": "<p>html testing</p>",
									"delta": []
								},
								"email_address": "john.doe@example.com",
								"frequency": "3",
								"last_report_sent": "2024-11-24T07:31:11Z",
								"school": null
							}
						},
					},
					{
						id: 'edit-report-delivery',
						heading: 'edit_report_delivery',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/report/report_delivery/',
						description: ['edit_report_delivery_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'template',
									type: 'string',
									description: 'template_param_description'
								},
								{
									parameter: 'email_address',
									type: 'string',
									description: 'email_address_param_description'
								},
								{
									parameter: 'frequency',
									type: 'string',
									description: 'frequency_param_description'
								},
								{
									parameter: 'last_report_sent',
									type: 'date',
									description: 'last_report_sent_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'school',
									type: 'object',
									description: 'school_param_description'
								}
							]

						},
						requestObject: {
							id: 'edit-report-delivery',
							method: "PUT",
							endpoint: "/report/report_delivery/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 3,
								"template": "<p>html testing</p>",
								"email_address": "john.doe@example.com",
								"frequency": "3",
								"last_report_sent": "2024-11-24T07:31:11Z",
								"modify_at": "2024-12-24T07:35:14.277867Z",
								"created_at": "2024-12-24T07:35:14.277876Z",
								"school": null
							}
						},
					},
					{
						id: 'delete-report-delivery',
						heading: 'delete_report_delivery',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/report/report_delivery/?id=4',
						description: ['delete_report_delivery_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-report-delivery',
							method: "DELETE",
							endpoint: "/report/report_delivery/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						},
					},
				]
			},

			// ____________ Schools __________________
			{
				id: 'school',
				heading: 'school',
				groupDescription: 'school_group_description',
				subSections: [
					{
						id: 'create-school',
						heading: 'create_school',
						httpRequest: 'POST https://dashboard-api.mereos.eu/school/school/',
						description: ['create_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email_address',
									type: 'string',
									description: 'email_address_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'integer',
									description: 'phone_number_param_description'
								},
								{
									parameter: 'street_address',
									type: 'string',
									description: 'street_address_param_description'
								},
								{
									parameter: 'city',
									type: 'string',
									description: 'city_param_description'
								},
								{
									parameter: 'state',
									type: 'string',
									description: 'state_param_description'
								},
								{
									parameter: 'country',
									type: 'string',
									description: 'country_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-school',
							method: "POST",
							endpoint: "/school/school/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "School Name",
								"email_address": "school.name@example.com",
								"phone_number": "32423423423",
								"street_address": "Address",
								"city": "city",
								"state": "state",
								"country": "country",
								"status": "Active",
								"created_at": "2022-12-12T05:12:46.129200Z"
							}
						},
					},
					{
						id: 'edit-school',
						heading: 'edit_school',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/school/school/',
						description: ['edit_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'email_address',
									type: 'string',
									description: 'email_address_param_description'
								},
								{
									parameter: 'phone_number',
									type: 'integer',
									description: 'phone_number_param_description'
								},
								{
									parameter: 'street_address',
									type: 'string',
									description: 'street_address_param_description'
								},
								{
									parameter: 'city',
									type: 'string',
									description: 'city_param_description'
								},
								{
									parameter: 'state',
									type: 'string',
									description: 'state_param_description'
								},
								{
									parameter: 'country',
									type: 'string',
									description: 'country_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-school',
							method: "PUT",
							endpoint: "/school/school/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 3,
								"name": "School Name",
								"email_address": "school.name@example.com",
								"phone_number": "32423423423",
								"street_address": "Address",
								"city": "city",
								"state": "state",
								"country": "country",
							}
						},
					},
					{
						id: 'delete-school',
						heading: 'delete_school',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/school/school/',
						description: ['delete_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-school',
							method: "DELETE",
							endpoint: "/school/school/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-school',
						heading: 'get_all_school',
						httpRequest: 'GET https://dashboard-api.mereos.eu/school/school/?id=1&page=1&range=25',
						description: ['all_school_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-school',
							method: "GET",
							endpoint: "/school/school/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 1,
								page: 1,
								range: 25
							}
						},
					},
				]
			},

			// ____________ Sections __________________
			{
				id: 'section',
				heading: 'section',
				groupDescription: 'section_group_description',
				subSections: [
					{
						id: 'get-section',
						heading: 'get_section',
						httpRequest: 'GET https://dashboard-api.mereos.eu/assessment/section/?assessment=53&secure_feature_profile=16&name__icontains=Backend developer&allow_interruption=true&id=677&page=1&range=1&$expand=assessment.status, assessment.owner',
						description: ['get_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'assessment',
									optional: true,
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'secure_feature_profile',
									optional: true,
									type: 'integer',
									description: 'secure_feature_profile_param_description'
								},
								{
									parameter: 'name__icontains',
									optional: true,
									type: 'string',
									description: 'name__icontains_param_description'
								},
								{
									parameter: 'allow_interruption',
									optional: true,
									type: 'boolean',
									description: 'allow_interruption_param_description'
								},
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}
								]
						},
						requestObject: {
							id: 'get-section',
							method: "GET",
							endpoint: "/assessment/section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								assessment: 53,
								secure_feature_profile: 16,
								name__icontains: "Backend developer",
								allow_interruption: true,
								id: 677,
								page: 1,
								range: 1,
								$expand: "assessment.status, assessment.owner"
							}
						},
					},
					{
						id: 'create-section',
						heading: 'create_section',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/section/',
						description: ['create_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'questions',
									type: 'object',
									description: 'questions_param_description'
								},
								{
									parameter: 'rating',
									type: 'integer',
									description: 'rating_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'assessment',
									type: 'integer',
									description: 'assessment_param_description'
								},
								{
									parameter: 'secure_feature_profile',
									type: 'integer',
									description: 'secure_feature_profile_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-section',
							method: "POST",
							endpoint: "/assessment/section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"questions": {
									"demo": "demo"
								},
								"rating": 1,
								"name": "Final testing",
								"assessment": 5,
								"secure_feature_profile": 1
							}
						},
					},
					{
						id: 'edit-section',
						heading: 'edit_section',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/assessment/section/',
						description: ['edit_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'assessment',
									type: 'object',
									description: 'assessment_param_description'
								},
								{
									parameter: 'activity',
									type: 'object',
									description: 'activity_for_edit_section_description'
								},
								{
									parameter: 'secure_feature_profile',
									type: 'object',
									description: 'secure_feature_profile_param_description'
								},
								{
									parameter: 'questions',
									type: 'array',
									description: 'questions_param_description'
								},
								{
									parameter: 'rating',
									type: 'integer',
									description: 'rating_param_description'
								},
								{
									parameter: 'allow_interruption',
									type: 'boolean',
									description: 'allow_interruption_param_description'
								},
								{
									parameter: 'status',
									type: 'string',
									description: 'status_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-section',
							method: "PUT",
							endpoint: "/assessment/section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 83,
								"name": "John Doe",
								"assessment": {
									"id": 6,
									"owner": {
										"id": 13,
										"username": "john_doe",
										"first_name": "John",
										"last_name": "Doe",
										"img": "file"
									},
									"name": "Section Name",
									"description": "",
									"status": "opened",
									"summary": "summary",
									"end_at": "2023-12-31T06:20:27Z",
									"start_at": "2023-03-17T06:20:28Z",
									"assessment_link": null,
									"created_at": "2023-05-25T07:07:33.034517Z",
									"school": 2
								},
								"activity": {},
								"secure_feature_profile": {
									"id": 6,
									"entity_relation": [
										{
											"id": 41,
											"name": "Check Network",
											"tooltip": "Check Network",
											"image": "/media/proctoring-icons/tampering.svg",
											"created_at": "2023-05-17T10:28:19.381136Z",
											"entity_group": 3,
											"dependency": [
												34
											],
											"combination": []
										}
									],
									"url_filtering": [],
									"name": "Midterm",
									"description": "description",
									"created_at": "2023-04-10T08:06:38.909537Z",
									"school_id": 2
								},
								"questions": [],
								"rating": 1,
								"allow_interruption": false,
								"status": "Active"
							}
						},
					},
					{
						id: 'delete-section',
						heading: 'delete_section',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/assessment/section/?id=83',
						description: ['delete_section_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-section',
							method: "DELETE",
							endpoint: "/assessment/section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 83
							}
						},
					},
					{
						id: 'get-section-by-candidate',
						heading: 'get_section_by_candidate',
						httpRequest: 'POST https://dashboard-api.mereos.eu/assessment/public_section/?section_id=58',
						description: ['get_section_by_candidate_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'section_id',
									type: 'integer',
									description: 'section_id_param_description'
								}]
						},
						requestObject: {
							id: 'get-section-by-candidate',
							method: "POST",
							endpoint: "/assessment/public_section/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"section_id": 83
							}
						},
					},
				]
			},

			// ______________Section Sessions ________________
			{
				id: 'section-sessions',
				heading: 'section_sessions',
				groupDescription: 'section_sessions_group_description',
				subSections: [
					{
						id: 'create-section-session',
						heading: 'create_section_session',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/section_session/',
						description: ['create_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'collected_details',
									type: 'object',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'integer',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'candidate_identity_card',
									type: 'url',
									description: 'candidate_identity_card_param_description'
								},
								{
									parameter: 'candidate_photo',
									type: 'url',
									description: 'candidate_photo_param_description'
								},
								{
									parameter: 'submission_time',
									type: 'date',
									description: 'submission_time_param_description'
								},
								{
									parameter: 'candidate_invite_assessment_section',
									type: 'integer',
									description: 'candidate_invite_assessment_section_param_description'
								},
								{
									parameter: 'session_report',
									type: 'array',
									description: 'session_report_for_create_section_session_description'
								},
								{
									parameter: 'section',
									type: 'integrer',
									description: 'section_param_description'
								},
								{
									parameter: 'candidate',
									type: 'integrer',
									description: 'candidate_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-section-session',
							method: "POST",
							endpoint: "/section_session/section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"collected_details": {},
								"duration_taken": 120000,
								"candidate_identity_card": "file",
								"candidate_photo": "file",
								"submission_time": "2023-11-12 12:12:12",
								"candidate_invite_assessment_section": 180,
								"section": 266,
								"candidate": 272,
								"session_report": []
							}
						},
					},
					{
						id: 'edit-section-session',
						heading: 'edit_section_session',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/section_session/section_session/',
						description: ['edit_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'collected_details',
									type: 'object',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'integer',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'candidate_identity_card',
									type: 'url',
									description: 'candidate_identity_card_param_description'
								},
								{
									parameter: 'candidate_photo',
									type: 'url',
									description: 'candidate_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'incident_score',
									type: 'string',
									description: 'incident_score_for_edit_section_session_description'
								},
								{
									parameter: 'processed_anomalies',
									type: 'string',
									description: 'processed_anomalies_for_edit_section_session_description'
								},
								{
									parameter: 'final_score',
									type: 'integer',
									description: 'final_score_for_edit_section_session_description'
								},
								{
									parameter: 'processed_events',
									type: 'array',
									description: 'processed_events_for_edit_section_session_description'
								},
								{
									parameter: 'browser_events',
									type: 'array',
									description: 'browser_events_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'camera_recordings',
									type: 'array',
									description: 'camera_recordings_param_description'
								},
								{
									parameter: 'screen_recordings',
									type: 'array',
									description: 'screen_recordings_param_description'
								},
								{
									parameter: 'roomscan_recordings',
									type: 'array',
									description: 'roomscan_recordings_param_description'
								},
								{
									parameter: 'audio_recordings',
									type: 'array',
									description: 'audio_recordings_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'room_id',
									type: 'integer',
									description: 'room_id_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'ai_events',
									type: 'array',
									description: 'ai_events_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								},
								{
									parameter: 'candidate_invite_assessment_section',
									type: 'integer',
									description: 'candidate_invite_assessment_section_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-section-session',
							method: "PUT",
							endpoint: "/section_session/section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 189,
								"collected_details": {},
								"duration_taken": 120000,
								"candidate_identity_card": "file",
								"candidate_photo": "file",
								"incident_level": "",
								"incident_score": "",
								"processed_anomalies": null,
								"final_score": null,
								"processed_events": [],
								"browser_events": [],
								"start_time": null,
								"camera_recordings": [],
								"screen_recordings": [],
								"roomscan_recordings": [],
								"audio_recordings": [],
								"session_id": 123,
								"room_id": null,
								"video_codec": null,
								"video_extension": null,
								"ai_events": [],
								"created_at": "2024-03-22T06:36:37.753825Z",
								"candidate_invite_assessment_section": 180
							}
						},
					},
					{
						id: 'delete-section-session',
						heading: 'Delete section session',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/section_session/section_session/',
						description: ['delete_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-section-session',
							method: "DELETE",
							endpoint: "/section_session/section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'search-section-session',
						heading: 'Search section session',
						httpRequest: `GET https://dashboard-api.mereos.eu/section_session/section_session_search/?search=&page=1&range=25&including_columns=id&q=Q(candidate_invite_assessment_section__candidate_assessment__candidate__first_name__icontains=John, candidate_invite_assessment_section__candidate_assessment__candidate__last_name__icontains=Doe)&$expand=candidate_invite_assessment_section.candidate_assessment.candidate,candidate_invite_assessment_section.candidate_assessment.assessment,candidate_invite_assessment_section.candidate_assessment.status,candidate_invite_assessment_section.section,candidate_invite_assessment_section.status&attach=events,ai_events&unattach=mobile_audio_recordings,location,mobile_recordings,roomscan_recordings,screen_recordings,audio_recordings,camera_recordings`,
						description: ['search_section_sessions_api_description', 'search_filters_attach_expand_guide_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'search',
									optional: true,
									type: 'string',
									description: 'search_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: 'q',
									optional: true,
									type: 'string',
									description: 'q_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								},
								{
									parameter: 'including_columns',
									optional: true,
									type: 'array',
									description: 'including_columns_param_description'
								},
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'search-section-session',
							method: "GET",
							endpoint: "/section_session/section_session_search/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								search: "",
								page: 1,
								range: 25,
								including_columns: "id",
								q: "Q(candidate_invite_assessment_section__candidate_assessment__candidate__first_name__icontains=John, candidate_invite_assessment_section__candidate_assessment__candidate__last_name__icontains=Doe)",
								$expand: "candidate_invite_assessment_section.candidate_assessment.candidate,candidate_invite_assessment_section.candidate_assessment.assessment,candidate_invite_assessment_section.candidate_assessment.status,candidate_invite_assessment_section.section,candidate_invite_assessment_section.status",
								attach: "events,ai_events",
								unattach: "mobile_audio_recordings,location,mobile_recordings,roomscan_recordings,screen_recordings,audio_recordings,camera_recordings"
							}
						},
					},
					{
						id: 'get-all-section-session',
						heading: 'Get all section session',
						httpRequest: 'GET https://dashboard-api.mereos.eu/section_session/section_session/?attach=events,ai_events&unattach=playlist',
						description: ['all_section_sessions_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'attach',
									optional: true,
									type: 'string',
									description: 'attach_param_description'
								},
								{
									parameter: 'unattach',
									optional: true,
									type: 'string',
									description: 'unattach_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-section-session',
							method: "GET",
							endpoint: "/section_session/section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								attach: "events,ai_events",
								unattach: "playlist"
							}
						},
					},
					{
						id: 'create-candidate-section-session',
						heading: 'create_candidate_section_session',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/candidate_section_session/',
						description: ['create_candidate_section_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'audio_recordings',
									type: 'array',
									description: 'audio_recordings_param_description'
								},
								{
									parameter: 'browser_events',
									type: 'array',
									description: 'browser_events_param_description'
								},
								{
									parameter: 'camera_recordings',
									type: 'array',
									description: 'camera_recordings_param_description'
								},
								{
									parameter: 'candidate_identity_card',
									type: 'url',
									description: 'candidate_identity_card_param_description'
								},
								{
									parameter: 'candidate_photo',
									type: 'url',
									description: 'candidate_photo_param_description'
								},
								{
									parameter: 'collected_details',
									type: 'object',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'integer',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'roomscan_recordings',
									type: 'array',
									description: 'roomscan_recordings_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'screen_recordings',
									type: 'array',
									description: 'screen_recordings_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'candidate_invite_assessment_section',
									type: 'integer',
									description: 'candidate_invite_assessment_section_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-candidate-section-session',
							method: "POST",
							endpoint: "/section_session/candidate_section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body:
							{
								"audio_recordings": ["recording link"],
								"browser_events": [],
								"camera_recordings": ["recording link"],
								"candidate_identity_card": "file",
								"candidate_photo": "file",
								"collected_details": { "location": { "latitude": 33.6628296, "longitude": 72.9965994 } },
								"duration_taken": 16210,
								"instructor": 15,
								"roomscan_recordings": "recording link",
								"school": 1,
								"screen_recordings": ["recording link"],
								"session_id": "abc-def-123-456",
								"start_time": 1696483282668,
								"video_codec": null,
								"video_extension": null,
								"candidate_invite_assessment_section": 2599
							}
						},
					},
					{
						id: 'candidate-edit-section-session',
						heading: 'candidate_edit_section_session',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/candidate_edit_section_session/',
						description: ['candidate_edit_section_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'audio_recordings',
									type: 'array',
									description: 'audio_recordings_param_description'
								},
								{
									parameter: 'browser_events',
									type: 'array',
									description: 'browser_events_param_description'
								},
								{
									parameter: 'camera_recordings',
									type: 'array',
									description: 'camera_recordings_param_description'
								},
								{
									parameter: 'candidate_identity_card',
									type: 'url',
									description: 'candidate_identity_card_param_description'
								},
								{
									parameter: 'candidate_photo',
									type: 'url',
									description: 'candidate_photo_param_description'
								},
								{
									parameter: 'collected_details',
									type: 'object',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'integer',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'instructor',
									type: 'integer',
									description: 'instructor_param_description'
								},
								{
									parameter: 'roomscan_recordings',
									type: 'array',
									description: 'roomscan_recordings_param_description'
								},
								{
									parameter: 'school',
									type: 'integer',
									description: 'school_param_description'
								},
								{
									parameter: 'screen_recordings',
									type: 'array',
									description: 'screen_recordings_param_description'
								},
								{
									parameter: 'session_id',
									type: 'integer',
									description: 'session_id_param_description'
								},
								{
									parameter: 'start_time',
									type: 'date',
									description: 'start_time_param_description'
								},
								{
									parameter: 'video_codec',
									type: 'string',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'string',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'candidate_invite_assessment_section',
									type: 'integer',
									description: 'candidate_invite_assessment_section_param_description'
								}
							]
						},
						requestObject: {
							id: 'candidate-edit-section-session',
							method: "POST",
							endpoint: "/section_session/candidate_edit_section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 191,
								"audio_recordings": ["recording link"],
								"browser_events": [],
								"camera_recordings": ["recording link"],
								"candidate": 289,
								"candidate_identity_card": "file",
								"candidate_photo": "file",
								"collected_details": { "location": { "latitude": 33.6628296, "longitude": 72.9965994 } },
								"duration_taken": 16210,
								"instructor": 15,
								"roomscan_recordings": "recording link",
								"school": 1,
								"screen_recordings": ["recording link"],
								"section": 88,
								"session_id": "123-abc-def",
								"start_time": 1696483282668,
								"video_codec": null,
								"video_extension": null,
								"candidate_invite_assessment_section": 207
							}
						},
					},
					{
						id: 'get-or-create-section-session',
						heading: 'get_or_create_section_session',
						httpRequest: 'POST https://dashboard-api.mereos.eu/section_session/get_or_create_section_session/',
						description: ['get_or_create_section_session_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'candidate_invite_assessment_section',
									type: 'integer',
									description: 'candidate_invite_assessment_section_param_description'
								},
								{
									parameter: 'playlist',
									type: 'object',
									description: 'playlist_param_description'
								},
								{
									parameter: 'evaluation',
									type: 'object',
									description: 'evaluation_param_description'
								},
								{
									parameter: 'panel',
									type: 'object',
									description: 'panel_for_get_or_create_section_session_description'
								},
								{
									parameter: 'collected_details',
									type: 'object',
									description: 'collected_details_param_description'
								},
								{
									parameter: 'duration_taken',
									type: 'integer',
									description: 'duration_taken_param_description'
								},
								{
									parameter: 'candidate_identity_card',
									type: 'string',
									description: 'candidate_identity_card_param_description'
								},
								{
									parameter: 'candidate_photo',
									type: 'string',
									description: 'candidate_photo_param_description'
								},
								{
									parameter: 'incident_level',
									type: 'string',
									description: 'incident_level_param_description'
								},
								{
									parameter: 'start_time',
									type: 'string',
									description: 'start_time_param_description'
								},
								{
									parameter: 'camera_recordings',
									type: 'array',
									description: 'camera_recordings_param_description'
								},
								{
									parameter: 'screen_recordings',
									type: 'array',
									description: 'screen_recordings_param_description'
								},
								{
									parameter: 'roomscan_recordings',
									type: 'string',
									description: 'roomscan_recordings_param_description'
								},
								{
									parameter: 'audio_recordings',
									type: 'array',
									description: 'audio_recordings_param_description'
								},
								{
									parameter: 'session_id',
									type: 'string',
									description: 'session_id_param_description'
								},
								{
									parameter: 'feedback_id',
									type: 'object',
									description: 'feedback_id_for_get_or_create_section_session_description'
								},
								{
									parameter: 'browser_version',
									type: 'object',
									description: 'browser_version_for_get_or_create_section_session_description'
								},
								{
									parameter: 'os_version',
									type: 'object',
									description: 'os_version_for_get_or_create_section_session_description'
								},
								{
									parameter: 'room_id',
									type: 'string',
									description: 'room_id_param_description'
								},
								{
									parameter: 'room_session_id',
									type: 'string',
									description: 'room_session_id_for_get_or_create_section_session_description'
								},
								{
									parameter: 'video_codec',
									type: 'object',
									description: 'video_codec_param_description'
								},
								{
									parameter: 'video_extension',
									type: 'object',
									description: 'video_extension_param_description'
								},
								{
									parameter: 'conversation_id',
									type: 'string',
									description: 'conversation_id_param_description'
								},
								{
									parameter: 'mobile_recordings',
									type: 'array',
									description: 'mobile_recordings_for_get_or_create_section_session_description'
								},
								{
									parameter: 'mobile_audio_recordings',
									type: 'array',
									description: 'mobile_audio_recordings_for_get_or_create_section_session_description'
								},
								{
									parameter: 'ip_address',
									type: 'string',
									description: 'ip_address_param_description'
								},
								{
									parameter: 'os',
									type: 'string',
									description: 'os_param_description'
								},
								{
									parameter: 'browser',
									type: 'string',
									description: 'browser_param_description'
								},
								{
									parameter: 'location',
									type: 'object',
									description: 'location_param_description'
								},
								{
									parameter: 'modify_at',
									type: 'date',
									description: 'modify_at_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
								]

						},
						requestObject: {
							id: 'get-or-create-section-session',
							method: "POST",
							endpoint: "/section_session/get_or_create_section_session/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"candidate_invite_assessment_section": 3563,
								"playlist": null,
								"evaluation": null,
								"panel": null,
								"collected_details": {},
								"duration_taken": 61946,
								"candidate_identity_card": "",
								"candidate_photo": "",
								"incident_level": "high",
								"start_time": "1749033162602",
								"camera_recordings": [
									"recording link"
								],
								"screen_recordings": [],
								"roomscan_recordings": "",
								"audio_recordings": [],
								"session_id": "session_id",
								"feedback_id": null,
								"browser_version": null,
								"os_version": null,
								"room_id": "room_id",
								"room_session_id": "room_session_id",
								"video_codec": null,
								"video_extension": null,
								"conversation_id": "conversation_id",
								"mobile_recordings": [],
								"mobile_audio_recordings": [],
								"ip_address": "172.31.18.87",
								"os": "Windows",
								"browser": "Chrome",
								"location": {},
								"modify_at": "2025-06-04T05:33:46.540742Z",
								"created_at": "2025-06-04T05:32:34.866680Z"
							}

						},
					},
				]
			},

			// _____________ Secure Feature Profile _______________
			{
				id: 'secure-feature-profile',
				heading: 'secure_feature_profile',
				groupDescription: 'secure_feature_profile_group_description',
				subSections: [
					{
						id: 'create-profile',
						heading: 'create_profile',
						httpRequest: 'POST https://dashboard-api.mereos.eu/profile/secure_feature_profile/',
						description: ['create_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'url_filtering',
									type: 'array',
									description: 'url_filtering_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'entity_relation',
									type: 'array',
									description: 'entity_relation_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'create-profile',
							method: "POST",
							endpoint: "/profile/secure_feature_profile/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"name": "Neutral",
								"url_filtering": [
									"http://example.com",
									"http://facebook.com"
								],
								"description": "This is a first assessment",
								"entity_relation": [337],
								"created_at": "2024-02-21T11:59:57.436938Z"
							}
						},
					},
					{
						id: 'edit-profile',
						heading: 'edit_profile',
						httpRequest: 'PUT https://dashboard-api.mereos.eu/profile/secure_feature_profile/',
						description: ['edit_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'name',
									type: 'string',
									description: 'name_param_description'
								},
								{
									parameter: 'url_filtering',
									type: 'array',
									description: 'url_filtering_param_description'
								},
								{
									parameter: 'description',
									type: 'string',
									description: 'description_param_description'
								},
								{
									parameter: 'entity_relation',
									optional: true,
									type: 'array',
									description: 'entity_relation_param_description'
								},
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'created_at',
									type: 'date',
									description: 'created_at_param_description'
								}
							]
						},
						requestObject: {
							id: 'edit-profile',
							method: "PUT",
							endpoint: "/profile/secure_feature_profile/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								"id": 8,
								"name": "Neutral Update 8",
								"url_filtering": [
									"http://example.com",
									"http://facebook.com"
								],
								"description": "This is a last assessment",
								"entity_relation": [337],
								"created_at": "2024-02-21T11:59:57.436938Z"
							}
						},
					},
					{
						id: 'delete-profile',
						heading: 'Delete profile',
						httpRequest: 'DELETE https://dashboard-api.mereos.eu/profile/secure_feature_profile/',
						description: ['delete_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									type: 'integer',
									description: 'id_param_description'
								},
							]
						},
						requestObject: {
							id: 'delete-profile',
							method: "DELETE",
							endpoint: "/profile/secure_feature_profile/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 4
							}
						}
					},
					{
						id: 'get-all-profiles',
						heading: 'get_all_profiles',
						httpRequest: 'GET https://dashboard-api.mereos.eu/profile/secure_feature_profile/?id=155&page=1&range=25&$expand=entity_relation',
						description: ['all_profile_api_description'],
						table: {
							columns: [
								{
									heading: `${'parameter'}`,
									accessor: 'parameter'
								},
								{
									heading: `${'type'}`,
									accessor: 'type'
								},
								{
									heading: `${'description'}`,
									accessor: 'description'
								},
							],
							data: [
								{
									parameter: 'id',
									optional: true,
									type: 'integer',
									description: 'id_param_description'
								},
								{
									parameter: 'page',
									optional: true,
									type: 'integer',
									description: 'page_param_description'
								},
								{
									parameter: 'range',
									optional: true,
									type: 'integer',
									description: 'range_param_description'
								},
								{
									parameter: '$expand',
									optional: true,
									type: 'string',
									description: 'expand_param_description'
								}]
						},
						requestObject: {
							id: 'get-all-profiles',
							method: "GET",
							endpoint: "/profile/secure_feature_profile/",
							host: "https://dashboard-api.mereos.eu",
							contentType: "application/json",
							body: {
								id: 155,
								page: 1,
								range: 25,
								$expand: "entity_relation"
							}
						},
					},
				]
			},
		]
	}
];
